(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bxgy-claim-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var picker = document.getElementById('bxgy-picker');
    if (!picker) return;

    var pill = document.getElementById('bxgy-claim');
    var openBtn = document.getElementById('bxgy-claim-open');
    var backdrop = document.getElementById('bxgy-picker-backdrop');
    var closeBtn = document.getElementById('bxgy-picker-close');
    var titleEl = document.getElementById('bxgy-picker-title');
    var subEl = document.getElementById('bxgy-picker-sub');
    var fillEl = document.getElementById('bxgy-picker-fill');
    var progressLabelEl = document.getElementById('bxgy-picker-progress-label');
    var listEl = document.getElementById('bxgy-picker-list');
    var confirmBtn = document.getElementById('bxgy-picker-confirm');
    var lightbox = document.getElementById('bxgy-picker-lightbox');
    var lightboxBackdrop = document.getElementById('bxgy-picker-lightbox-backdrop');
    var lightboxClose = document.getElementById('bxgy-picker-lightbox-close');
    var lightboxImg = document.getElementById('bxgy-picker-lightbox-img');
    if (!pill || !openBtn) return;

    function parseJSON(id, fallback) {
      var el = document.getElementById(id);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent) || fallback; } catch (e) { return fallback; }
    }

    var bxgy = parseJSON('bxgy-shared-config-data', null);
    var ladder = parseJSON('bxgy-shared-ladder-data', {}) || {};
    var rewardProducts = parseJSON('bxgy-claim-reward-products', []) || [];
    if (!bxgy || !bxgy.tiers || !bxgy.tiers.length) return;

    var tiers = bxgy.tiers.slice().sort(function (a, b) { return (a.buyMeters || 0) - (b.buyMeters || 0); });
    var REWARD_LABEL = (bxgy.rewardMessage || 'GET METERS FREE').toUpperCase();

    // 2026-08-13: highest tier index that is NOT wholesale-segment — a
    // guest's claim pill is capped here regardless of real cart size (guest
    // identity can't be told apart from a genuine wholesale account server-
    // side either, so the pill must never dangle a wholesale-tier reward in
    // front of someone who hasn't proven they're entitled to it). Computed
    // once from the same tiers array driving everything else, not
    // hardcoded to a buyMeters number, so it stays correct if/when the
    // bxgy_config metafield's segment labels change (known pending fix,
    // see project_wholesale-order-summary-pill memory).
    var lastNonWholesaleIndex = -1;
    for (var lnwi = tiers.length - 1; lnwi >= 0; lnwi--) {
      if (tiers[lnwi].segment !== 'wholesale') { lastNonWholesaleIndex = lnwi; break; }
    }

    var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
    var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });

    function getMetersPerUnit(sku) {
      if (!sku) return 1;
      var match = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!match) return 1;
      var value = Number(match[1]);
      return isFinite(value) && value > 0 ? value : 1;
    }
    function getEffectiveMeters(line) {
      return (line.quantity || 0) * getMetersPerUnit(line.sku);
    }
    function isBuyEligible(line) {
      if (!eligTypes.length && !eligIds.length) return true;
      var t = String(line.product_type || '').toLowerCase();
      if (eligTypes.indexOf(t) !== -1) return true;
      if (eligIds.indexOf(String(line.product_id)) !== -1) return true;
      return false;
    }
    function fmt(n) {
      n = Math.round(n * 10) / 10;
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    }
    function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function buildRewardLines(lines, catMap, cats) {
      return lines.map(function (l, i) { return { i: i, l: l }; })
        .filter(function (e) {
          var c = catMap[String(e.l.product_id)];
          return c && cats.indexOf(c) !== -1;
        })
        .map(function (e) {
          var m = getMetersPerUnit(e.l.sku);
          return { i: e.i, variantId: String(e.l.variant_id), quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
        })
        .sort(function (a, b) { return a.perMeter - b.perMeter; });
    }

    // cheapest-per-effective-meter-first, up to capMeters total — the "can this tier's
    // full reward be given at all" allocation (no per-line dual-eligible restriction).
    function allocate(lines, catMap, buyEligibleIdx, cats, capMeters) {
      var rewardLines = buildRewardLines(lines, catMap, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      var perVariantFreed = {};
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var unitsAffordable = Math.floor(remaining / rl.mpu + 1e-9);
        var unitsToFree = Math.min(unitsAffordable, rl.quantity);
        if (unitsToFree <= 0) continue;
        var freed = unitsToFree * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (buyEligibleIdx[rl.i]) dualFreed += freed;
        perVariantFreed[rl.variantId] = (perVariantFreed[rl.variantId] || 0) + freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed, perVariantFreed: perVariantFreed };
    }

    // partial-cap allocation: non-dual donors keep being given away free (they cost
    // nothing against the buy total) up to capMeters, but dual-eligible donors stop
    // once their portion hits dualBudget — the max the tier's own threshold can absorb.
    function allocateBudgetCapped(lines, catMap, buyEligibleIdx, cats, capMeters, dualBudget) {
      var rewardLines = buildRewardLines(lines, catMap, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      var perVariantFreed = {};
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var isDual = !!buyEligibleIdx[rl.i];
        var maxByDualBudget = isDual ? Math.floor(Math.max(0, dualBudget - dualFreed) / rl.mpu + 1e-9) : Infinity;
        var unitsAffordable = Math.floor(remaining / rl.mpu + 1e-9);
        var unitsToFree = Math.min(unitsAffordable, rl.quantity, maxByDualBudget);
        if (unitsToFree <= 0) continue;
        var freed = unitsToFree * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (isDual) dualFreed += freed;
        perVariantFreed[rl.variantId] = (perVariantFreed[rl.variantId] || 0) + freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed, perVariantFreed: perVariantFreed };
    }

    /*
     * Matches the deployed Function's "walk ascending + partial cap" algorithm
     * (2026-07-31 backend change — replaces the old highest-to-lowest cascade). See
     * snippets/bxgy-progress-card.liquid's compute() for the full explanation of the
     * walk itself. This version additionally tracks the ACTUAL grant at the tier the
     * walk settles on: `tierFull` (that tier's nominal freeMeters), `pickerCap` (the
     * real ceiling right now — equals tierFull unless the walk stopped here due to a
     * budget shortfall, in which case it's the capped amount), `freed` (how much of
     * that ceiling is already realized by donor product currently in the cart — always
     * <= pickerCap), and `perVariantFreed` for the cart-line badge correction.
     */
    function compute(lines, catMap) {
      var lastGranted = null;
      var lastGrantedIndex = -1;
      var totalBuy = 0;
      var buyEligibleIdx = {};
      lines.forEach(function (l, i) {
        if (isBuyEligible(l)) {
          totalBuy += getEffectiveMeters(l);
          buyEligibleIdx[i] = true;
        }
      });

      for (var t = 0; t < tiers.length; t++) {
        var tier = tiers[t];
        var buyMeters = tier.buyMeters || 0;
        if (totalBuy < buyMeters - 1e-9) break; // haven't raw-reached this tier — stop, keep last granted (if any)

        var cats = tier.rewardCategories || [];
        var free = tier.freeMeters || 0;
        if (free <= 0 || !cats.length) break;

        var full = allocate(lines, catMap, buyEligibleIdx, cats, free);
        var paid = totalBuy - full.dualFreed;

        if (paid >= buyMeters - 1e-9) {
          // fully affordable at this tier — lock it in, keep climbing
          lastGranted = { tier: tier, cats: cats, tierFull: free, pickerCap: free, freed: full.freed, perVariantFreed: full.perVariantFreed };
          lastGrantedIndex = t;
          continue;
        }

        // shortfall — cap the dual give-away so paid stays at this tier's threshold.
        // Never let climbing make the reward worse: only take this capped partial if
        // it actually grants MORE meters than the lower tier already secured (or if
        // nothing was secured yet) — a higher tier's crumbs don't replace a lower
        // tier's real reward just because we tried climbing.
        var dualBudget = totalBuy - buyMeters;
        var capped = allocateBudgetCapped(lines, catMap, buyEligibleIdx, cats, free, dualBudget);
        if (!lastGranted || capped.freed > lastGranted.freed + 1e-9) {
          lastGranted = { tier: tier, cats: cats, tierFull: free, pickerCap: capped.freed, freed: capped.freed, perVariantFreed: capped.perVariantFreed };
          lastGrantedIndex = t;
        }
        break; // a tier that isn't fully affordable can't justify trying a higher one
      }
      if (lastGranted) {
        lastGranted.tierIndex = lastGrantedIndex;
        lastGranted.rawBuy = totalBuy;
      }
      return lastGranted;
    }

    var catMap = {};
    var initialLines = parseJSON('bxgy-claim-cart-lines', []) || [];
    initialLines.forEach(function (l) { if (l.category) catMap[String(l.product_id)] = l.category; });
    rewardProducts.forEach(function (r) { if (r.category) catMap[String(r.product_id)] = r.category; });

    // current cart quantity per variant, for pre-filling the picker's steppers
    var cartQtyByVariant = {};
    initialLines.forEach(function (l) { cartQtyByVariant[String(l.variant_id)] = l.quantity || 0; });

    var pctText = function (tier) {
      var pct = (tier.rewardDiscountPercent === undefined || tier.rewardDiscountPercent === null) ? 100 : tier.rewardDiscountPercent;
      return pct;
    };

    var currentState = null; // display state driving the pill/picker (chained tier — see updatePill)
    var lastState = null;    // raw compute() result, re-fed into updatePill() on MutationObserver re-apply
    var lastLines = [];      // lines array used for the last compute() call
    // 2026-08-13: logged-in-non-wholesale reaching a wholesale-segment tier —
    // read by the delegated #bxgy-claim-open click handler to redirect to
    // registration instead of opening the picker. wholesaleRegisterUrl is
    // read off registerNoteEl's own href each updatePill() call rather than
    // duplicating pages['wholesale'].url as a new data attribute.
    var wholesaleLocked = false;
    var wholesaleRegisterUrl = '';
    var pickerQty = {};      // variant_id -> selected qty, live picker state

    // #cart-summary's innerHTML gets replaced wholesale by assets/cart.js's
    // refreshSection() on every cart:updated event (fetches a fresh server render of
    // #cart-summary and swaps it in) — since the pill lives inside #cart-summary, its
    // DOM nodes get swapped out from under any cached references. Re-query fresh every
    // call rather than relying on the module-level `pill`/`textEl`/`openBtn` vars,
    // which only reflect whatever existed at page-load time.
    // pickerCap < tierFull means this tier's own reward budget can't afford its full
    // freeMeters right now (the new partial-cap case) — a genuinely different message
    // from "haven't picked enough donor fabric yet" (filled < pickerCap, same ceiling
    // just not yet realized by what's currently in cart).
    /*
     * Reads the discount Shopify actually applied (via lines' `bxgy_discount_amount`
     * / `original_line_price`, populated either from the initial Liquid render or
     * refreshFromServer()'s AJAX fetch) instead of trusting our own simulated
     * `freed` — ground truth for "already earned" that can't drift from the deployed
     * Function's exact allocation-order/tie-break rules the way a client-side
     * re-derivation can. The reward always discounts a line's FULL quantity (never a
     * sub-line split — same rule the cart-line badge fix relies on), so any line with
     * a nonzero matched amount contributes its whole meter quantity to `meters`.
     * Returns null (falls back to simulated state) whenever there's nothing to read
     * yet, OR when the derived percent lands outside a sane 0–100 range — guards
     * against a wrong AJAX field/unit guess ever displaying a garbage number instead
     * of silently deferring to the existing simulated value.
     */
    function computeRealEarned(lines) {
      var meters = 0, amount = 0, originalTotal = 0;
      (lines || []).forEach(function (l) {
        var amt = l.bxgy_discount_amount || 0;
        var orig = l.original_line_price || 0;
        if (amt <= 0 || orig <= 0) return;
        var m = getMetersPerUnit(l.sku);
        meters += (l.quantity || 0) * m;
        amount += amt;
        originalTotal += orig;
      });
      if (meters <= 1e-9 || originalTotal <= 0) return null;
      var pct = Math.round((amount / originalTotal) * 100);
      if (!(pct > 0 && pct <= 100)) return null;
      return { meters: meters, pct: pct };
    }

    function updatePill(state) {
      var pillEl = document.getElementById('bxgy-claim');
      var textElLive = document.getElementById('bxgy-claim-text');
      var subtitleElLive = document.getElementById('bxgy-claim-subtitle');
      var openBtnLive = document.getElementById('bxgy-claim-open');
      var appliedElLive = document.getElementById('bxgy-claim-applied');
      // Guest login nudge / wholesale-registration nudge (bxgy-claim-pill.liquid
      // renders at most one of the two, mutually exclusive via Liquid — neither
      // exists at all for a recognized wholesale customer). Kept in lockstep
      // with the pill itself, never shown before eligibility, never left
      // showing after the reward is no longer earned.
      var loginNoteEl = document.getElementById('bxgy-claim-login-note');
      var registerNoteEl = document.getElementById('bxgy-claim-register-note');
      // Order Summary pill (sections/main-cart.liquid) mirroring the same
      // wholesale nudge as loginNoteEl/registerNoteEl above, matching
      // VALUEPACK/PREPAID/MULTIMETER's pill UI — 2026-08-13.
      var wholesalePillEl = document.getElementById('wholesale-pill');
      if (!pillEl) return;
      if (!state) {
        pillEl.hidden = true;
        if (loginNoteEl) loginNoteEl.hidden = true;
        if (registerNoteEl) registerNoteEl.hidden = true;
        if (wholesalePillEl) wholesalePillEl.hidden = true;
        wholesaleLocked = false;
        pillEl.setAttribute('data-wholesale-locked', 'false');
        recountRewardsCount();
        return;
      }
      lastState = state; // raw compute() result — re-fed on MutationObserver re-apply, never the derived `display`

      var real = computeRealEarned(lastLines);
      var earnedMeters = real ? real.meters : state.freed;

      /*
       * Chains forward the SAME way bxgy-progress-card.liquid's simplified formula
       * does — explicit choice to let the pill match the progress card's pacing
       * instead of staying strictly tied to real applied $ only. Starting from
       * bestIndex, keep advancing through any tier whose raw threshold this same
       * formula (buyMeters - (totalBuy - realized)) already treats as met, landing
       * on the last one that's still satisfied. `realized` stays FIXED at bestIndex's
       * own real freed amount throughout — this is a display/eligibility estimate,
       * not a re-run of the rigorous dual-aware walk.
       */
      var chainRealized = state.freed || 0;
      var chainIndex = state.tierIndex;
      for (var ci = state.tierIndex + 1; ci < tiers.length; ci++) {
        var chainNeed = (tiers[ci].buyMeters || 0) - (state.rawBuy - chainRealized);
        if (chainNeed > 1e-9) break;
        chainIndex = ci;
      }

      // 2026-08-13: customer segment read off which wholesale nudge Liquid
      // rendered (bxgy-claim-pill.liquid renders at most one of the two,
      // neither for a recognized wholesale customer) — single source of
      // truth for "is this viewer wholesale-recognized" client-side,
      // nothing new to compute.
      var isGuestCustomer = !!loginNoteEl;
      var isNonWholesaleLoggedIn = !!registerNoteEl;

      // Guest: the pill never advances past the last non-wholesale tier no
      // matter how large the real cart is — dangling a wholesale-tier
      // reward in front of someone who hasn't proven that identity would be
      // actively misleading (they'd hit a wall at checkout/claim either
      // way). A logged-in-but-not-yet-wholesale customer is different: they
      // DO see the real reached tier (so they know exactly what they're
      // missing) — only the claim ACTION locks for them, below.
      var displayIndex = chainIndex;
      if (isGuestCustomer && lastNonWholesaleIndex >= 0 && chainIndex > lastNonWholesaleIndex) {
        displayIndex = lastNonWholesaleIndex;
      }
      var chainTier = tiers[displayIndex];

      // The picker's own cap is still always the DISPLAYED tier's full `tierFull` —
      // never the smaller dual-budget-capped ceiling — since selecting more through
      // this picker raises totalBuy, which can complete this tier's own threshold.
      var display = {
        tier: chainTier,
        cats: chainTier.rewardCategories || [],
        tierFull: chainTier.freeMeters || 0,
        pickerCap: chainTier.freeMeters || 0,
        freed: state.freed,
        perVariantFreed: state.perVariantFreed
      };
      currentState = display;

      // fully claimed only when the REAL applied discount matches this tier's own
      // full eligible amount (x) exactly — a lesser (partial or zero) applied amount
      // keeps the row in its default "Choose fabric" state
      var filled = earnedMeters >= display.tierFull - 1e-9;
      var basePct = pctText(display.tier);

      if (textElLive) {
        // "You're eligible for " prefix dropped 2026-08-12 — redundant once
        // this row lives inside a card literally titled "Rewards available".
        textElLive.textContent = fmt(display.tierFull) + ' ' + mUnit(display.tierFull) +
          (basePct >= 100 ? ' FREE' : ' at ' + basePct + '% off');
      }

      // Logged in, not yet wholesale-recognized, and the tier actually being
      // displayed (uncapped for this segment, see above) is wholesale-only —
      // the reward is real and visible, but claiming it requires the
      // account, so the button locks into a registration prompt instead of
      // the normal Choose fabric / Applied ✓ swap.
      wholesaleLocked = isNonWholesaleLoggedIn && display.tier.segment === 'wholesale';
      wholesaleRegisterUrl = registerNoteEl ? (registerNoteEl.getAttribute('href') || '') : '';

      if (wholesaleLocked) {
        if (openBtnLive) {
          openBtnLive.hidden = false;
          openBtnLive.textContent = 'Wholesale registration required';
        }
        if (appliedElLive) appliedElLive.hidden = true;
        if (pillEl) pillEl.setAttribute('data-applied', 'false');
        // 2026-08-13: "Wholesale registration required" is too long to sit
        // beside the title/subtitle in the normal single-line row layout
        // (reported cramped in a screenshot) — this attribute lets CSS drop
        // the button to a full-width line below instead.
        if (pillEl) pillEl.setAttribute('data-wholesale-locked', 'true');
        // "Pick your fabrics" doesn't apply here — there's nothing to pick,
        // the title above already states this exact tier's reward (shown
        // uncapped for this segment, see above), so this deliberately does
        // NOT repeat the number — just the reassurance + register nudge.
        if (subtitleElLive) subtitleElLive.textContent = 'You’ve unlocked our best available reward — register for wholesale to claim it';
      } else {
        // Once fully claimed, swap the (previously still-clickable "Change
        // fabric") button for a flat, non-interactive "Applied ✓" — matches
        // the LOYALTY/PREPAID rows' treatment in the same card. Re-picking
        // fabric after full claim is no longer possible from this row.
        if (openBtnLive) {
          openBtnLive.hidden = filled;
          openBtnLive.textContent = 'Choose fabric';
        }
        if (appliedElLive) appliedElLive.hidden = !filled;
        if (pillEl) pillEl.setAttribute('data-applied', filled ? 'true' : 'false');
        if (pillEl) pillEl.setAttribute('data-wholesale-locked', 'false');
        if (subtitleElLive) subtitleElLive.textContent = 'Pick your fabrics';
      }

      // 2026-08-13: "Choose fabric"/"Applied" row no longer hides itself at
      // the wholesale tier for guests — a guest still needs to be able to
      // pick their free fabric manually regardless of whether they might
      // ALSO have a wholesale account they haven't logged into yet. The
      // wholesale login/register nudges below are fully independent rows
      // (own visibility, own styling matching the other reward rows)
      // rather than something this row's own hidden state is coupled to.
      // isWholesaleTier deliberately reads the RAW reached tier (chainIndex,
      // uncapped) — not the guest-capped `display.tier` — so a guest still
      // gets the login nudge the moment their real cart crosses into
      // wholesale territory, even though the pill itself stays capped.
      var isWholesaleTier = !!(tiers[chainIndex] && tiers[chainIndex].segment === 'wholesale');
      pillEl.hidden = false;
      // 2026-08-12 fix (still applies): both nudges were being shown at ANY
      // reached tier (e.g. a 15m teaser tier) — gated on isWholesaleTier
      // since both are ABOUT the wholesale auto-apply behavior specifically,
      // neither should appear before the cart actually reaches that tier.
      if (loginNoteEl) loginNoteEl.hidden = !isWholesaleTier;
      if (registerNoteEl) registerNoteEl.hidden = !isWholesaleTier;
      if (wholesalePillEl) wholesalePillEl.hidden = !isWholesaleTier;
      recountRewardsCount();
    }

    // "N left" count in the shared Rewards card header — re-run after every
    // updatePill() call (initial load + every MutationObserver re-apply on
    // #cart-summary swap, see pillObserver below), fresh getElementById
    // lookups each time since refreshSection() replaces the whole subtree.
    // Card's own show/hide is pure CSS (:has() in cart-rewards-card.liquid),
    // not handled here — this only ever touches the count text.
    // "left" = visible row not yet marked data-applied="true"; LOYALTY/PREPAID
    // set that attribute server-side in Liquid, BXGY's row (above) sets it via
    // JS — this function doesn't care which, it only reads the attribute.
    function recountRewardsCount() {
      var countEl = document.getElementById('cart-rewards-count');
      if (!countEl) return;
      var rows = document.querySelectorAll('#cart-rewards .cart-reward-row:not([hidden])');
      var left = 0;
      rows.forEach(function (row) {
        if (row.getAttribute('data-applied') !== 'true') left++;
      });
      countEl.textContent = left > 0 ? left + ' to claim' : 'All claimed';
    }

    /*
     * Rows shown here get bulk-SET (not incremented) on Confirm — updates[variant_id]
     * = whatever the stepper shows, for every row present. That makes a raw cart-
     * quantity prefill dangerous for a DUAL product whose quantity is mostly plain
     * buy-quantity, not a reward donation: extending the picker to a wider category
     * set (see updatePill's `display` retarget) can pull in a line like an 8m dual
     * product that currently has ZERO of that 8m actually realized as a reward — if
     * shown, its full raw quantity would inflate the picker's total against a much
     * smaller cap (observed bug: "10 of 4 meters selected"), AND an untouched Confirm
     * would silently overwrite that line's real purchased quantity. Only show a row
     * when its current cart quantity is either 0 (a genuinely fresh, safe addition)
     * or already fully accounted for by `perVariantFreed` (the reward realized on it
     * matches its full quantity, so editing it here only adjusts the reward — no plain
     * buy-quantity hidden inside it to accidentally clobber). Anything in between (a
     * line partly buy, partly reward) is excluded — adjust that one from the cart page
     * itself, not this picker. Cart-already-present rows are also sorted first so
     * what's already selected is immediately visible instead of buried in the
     * catalog list. Everything else is sorted by free_gift_stock descending (surface
     * higher-stock fabrics first, per merchant request 2026-08-08, to help move
     * overstock through the free-gift mechanism), with price ascending as a
     * tie-break to preserve the original margin-protection default when stock is
     * equal.
     */
    /*
     * A cart line whose quantity is PARTLY realized as a reward (e.g. 1 of 9 meters
     * already getting the discount, 8 still plain buy-quantity — the Function's own
     * cheapest-first allocation didn't need the whole line) can't be an editable row
     * for the reason above, but it's still contributing real, already-applied
     * discount that the customer should be able to SEE. Surfaced separately as a
     * read-only line so the picker's own total reconciles with what's actually
     * earned, without exposing a stepper that would let Confirm's bulk-set clobber
     * the un-realized portion of that line's quantity.
     */
    /*
     * Merchant flagged (2026-09-29) that pure stock-desc sorting let "plain"
     * fabric — which reliably carries higher stock than the two
     * digital-printed lines — permanently occupy the top of the picker, so
     * almost every reward claim went to plain and the poly/pure overstock
     * this sort was built to move (see comment above) never got a look.
     * Already-in-cart rows keep their existing top-of-list priority
     * untouched. Everything else is grouped by fabric family (poly + pure
     * combined into one "digital" bucket — both are digital-printed lines
     * competing with plain the same way, per merchant confirmation) and
     * round-robined 2-at-a-time — plain, digital, plain, digital... — so
     * the within-bucket stock/price ordering from the sort above still
     * decides who wins first place inside their own bucket, but no single
     * bucket can bury the other at the top of the whole list.
     */
    var CATEGORY_INTERLEAVE_CHUNK = 2;
    var CATEGORY_INTERLEAVE_ORDER = ['plain', 'digital'];
    function categoryBucketKey(cat) {
      if (cat === 'poly' || cat === 'pure') return 'digital';
      return cat;
    }
    function interleaveByCategory(sortedList) {
      var inCartItems = [];
      var restItems = [];
      sortedList.forEach(function (item) {
        var inCart = (cartQtyByVariant[String(item.variant_id)] || 0) > 0;
        (inCart ? inCartItems : restItems).push(item);
      });

      var groups = {};
      var orderedKeys = [];
      restItems.forEach(function (item) {
        var key = categoryBucketKey(item.category);
        if (!groups[key]) {
          groups[key] = [];
          orderedKeys.push(key);
        }
        groups[key].push(item);
      });

      var keyOrder = CATEGORY_INTERLEAVE_ORDER
        .filter(function (k) { return orderedKeys.indexOf(k) !== -1; })
        .concat(orderedKeys.filter(function (k) { return CATEGORY_INTERLEAVE_ORDER.indexOf(k) === -1; }));

      var indices = {};
      keyOrder.forEach(function (k) { indices[k] = 0; });
      var interleaved = [];
      var more = true;
      while (more) {
        more = false;
        keyOrder.forEach(function (k) {
          var arr = groups[k];
          var idx = indices[k];
          if (idx >= arr.length) return;
          var end = Math.min(idx + CATEGORY_INTERLEAVE_CHUNK, arr.length);
          for (var i = idx; i < end; i++) interleaved.push(arr[i]);
          indices[k] = end;
          if (end < arr.length) more = true;
        });
      }

      return inCartItems.concat(interleaved);
    }

    function classifyProducts(state) {
      var freedByVariant = state.perVariantFreed || {};
      var editable = [];
      var readOnly = [];
      rewardProducts.forEach(function (r) {
        if (!r.available || getMetersPerUnit(r.sku) !== 1 || state.cats.indexOf(r.category) === -1) return;
        var vid = String(r.variant_id);
        var cartQty = cartQtyByVariant[vid] || 0;
        var freed = freedByVariant[vid] || 0;
        if (cartQty <= 1e-9 || cartQty <= freed + 1e-9) {
          editable.push(r);
        } else if (freed > 1e-9) {
          readOnly.push({ product: r, freed: freed, cartQty: cartQty });
        }
      });
      editable.sort(function (a, b) {
        var aInCart = (cartQtyByVariant[String(a.variant_id)] || 0) > 0;
        var bInCart = (cartQtyByVariant[String(b.variant_id)] || 0) > 0;
        if (aInCart !== bInCart) return aInCart ? -1 : 1;
        var stockDiff = (b.stock || 0) - (a.stock || 0);
        if (stockDiff !== 0) return stockDiff;
        return (a.price || 0) - (b.price || 0);
      });
      editable = interleaveByCategory(editable);
      return { editable: editable, readOnly: readOnly };
    }

    var pickerReadOnly = []; // [{product, freed, cartQty}] — display-only, never sent to Confirm

    function pickerTotal() {
      var t = 0;
      Object.keys(pickerQty).forEach(function (k) { t += pickerQty[k] || 0; });
      pickerReadOnly.forEach(function (r) { t += r.freed; });
      return t;
    }

    function renderPicker() {
      if (!currentState) return;
      var tier = currentState.tier;
      var pct = pctText(tier);
      var total = pickerTotal();
      var cap = currentState.pickerCap || 0; // the REAL ceiling right now, not tier.freeMeters

      var titlePct = pct >= 100 ? 'free' : 'at ' + pct + '% off';
      titleEl.textContent = 'Choose your ' + fmt(cap) + ' ' + mUnit(cap) + ' ' + titlePct;
      subEl.hidden = true; // no per-fabric explainer line — title + progress bar carry it

      var pctFill = cap > 0 ? Math.min(100, (total / cap) * 100) : 0;
      fillEl.style.width = pctFill + '%';
      progressLabelEl.textContent = fmt(total) + ' of ' + fmt(cap) + ' ' + mUnit(cap) + ' selected';

      // kept short deliberately — a persistent third-party chat widget docks at the
      // bottom-left of the viewport and overlapped the longer dynamic label; the
      // progress bar + "N of M selected" label above already carries that detail.
      confirmBtn.textContent = 'Confirm';
      confirmBtn.disabled = total < 1;

      var atCap = total >= cap;
      listEl.querySelectorAll('.bxgy-picker__row:not(.bxgy-picker__row--readonly)').forEach(function (row) {
        var vid = row.getAttribute('data-variant');
        var qty = pickerQty[vid] || 0;
        row.querySelector('.bxgy-picker__step-val').textContent = qty;
        row.querySelector('[data-action="plus"]').disabled = atCap;
        row.querySelector('[data-action="minus"]').disabled = qty < 1;
      });
    }

    function buildPickerList(state) {
      var classified = classifyProducts(state);
      listEl.innerHTML = '';
      pickerQty = {};
      pickerReadOnly = classified.readOnly;
      var pct = pctText(state.tier);
      // At the wholesale segment the reward is still the same picker/mechanism
      // (customer picks any fabric, same steppers, same Add flow) — just the
      // "Free"/"X% off" line under the name is hidden per merchant request,
      // since it reads oddly at wholesale scale. Cosmetic only, doesn't touch
      // eligibility, pricing, or the readonly "already applied" row below it.
      var hideRewardPct = state.tier && state.tier.segment === 'wholesale';

      // already-applied, non-editable — surfaced first so what's genuinely happening
      // right now is visible before the "add more" options below it.
      classified.readOnly.forEach(function (r) {
        var p = r.product;
        var row = document.createElement('div');
        row.className = 'bxgy-picker__row bxgy-picker__row--readonly';
        var swatch = p.image
          ? '<img class="bxgy-picker__swatch" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="52" height="52" data-full="' + escapeHtml(p.image_full || p.image) + '" data-title="' + escapeHtml(p.title) + '">'
          : '<div class="bxgy-picker__swatch bxgy-picker__swatch--placeholder"></div>';
        row.innerHTML = swatch +
          '<div class="bxgy-picker__row-body">' +
            '<p class="bxgy-picker__row-title">' + escapeHtml(p.title) + '</p>' +
            '<p class="bxgy-picker__row-meta">' + fmt(r.freed) + ' of ' + fmt(r.cartQty) + ' ' + mUnit(r.cartQty) +
              (pct >= 100 ? ' already free' : ' already at ' + pct + '% off') + '</p>' +
          '</div>';
        listEl.appendChild(row);
      });

      classified.editable.forEach(function (p) {
        var vid = String(p.variant_id);
        pickerQty[vid] = cartQtyByVariant[vid] || 0;

        var row = document.createElement('div');
        row.className = 'bxgy-picker__row';
        row.setAttribute('data-variant', vid);
        var swatch = p.image
          ? '<img class="bxgy-picker__swatch" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="52" height="52" data-full="' + escapeHtml(p.image_full || p.image) + '" data-title="' + escapeHtml(p.title) + '">'
          : '<div class="bxgy-picker__swatch bxgy-picker__swatch--placeholder"></div>';
        row.innerHTML = swatch +
          '<div class="bxgy-picker__row-body">' +
            '<p class="bxgy-picker__row-title">' + escapeHtml(p.title) + '</p>' +
            (hideRewardPct ? '' : '<p class="bxgy-picker__row-meta">' + (pct >= 100 ? 'Free' : pct + '% off') + '</p>') +
          '</div>' +
          '<div class="bxgy-picker__stepper">' +
            '<button type="button" class="bxgy-picker__step-btn" data-action="minus" aria-label="Decrease">−</button>' +
            '<span class="bxgy-picker__step-val">0</span>' +
            '<button type="button" class="bxgy-picker__step-btn" data-action="plus" aria-label="Increase">+</button>' +
          '</div>';
        listEl.appendChild(row);
      });
      renderPicker();
    }

    function openPicker() {
      if (!currentState) return;
      buildPickerList(currentState);
      picker.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closePicker() {
      picker.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      closeLightbox();
    }

    // Full-screen fabric preview, opened by tapping a row's swatch — the 52px
    // thumbnail is too small to judge a print/color from. Layered above the picker
    // itself (z-index 1100 vs the picker's 1000) rather than replacing it, so
    // closing the lightbox returns straight to the still-open picker.
    function openLightbox(src, alt) {
      if (!src) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function closeLightbox() {
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
    }

    // delegated on document, not bound to the #bxgy-claim-open node directly — that
    // node gets replaced (see updatePill's comment above) so a direct listener would
    // go dead after the first cart update.
    document.addEventListener('click', function (e) {
      if (e.target.closest('#bxgy-claim-open')) {
        // 2026-08-13: locked state (logged in, not wholesale-recognized,
        // reached tier is wholesale-segment) — button reads "Wholesale
        // registration required", send them to register instead of opening
        // a picker for a reward they can't actually claim yet.
        if (wholesaleLocked) {
          if (wholesaleRegisterUrl) window.location.href = wholesaleRegisterUrl;
          return;
        }
        openPicker();
      }
    });
    closeBtn.addEventListener('click', closePicker);
    backdrop.addEventListener('click', closePicker);
    lightboxClose.addEventListener('click', closeLightbox);
    lightboxBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (lightbox.getAttribute('aria-hidden') === 'false') closeLightbox();
    });

    listEl.addEventListener('click', function (e) {
      var swatch = e.target.closest('.bxgy-picker__swatch');
      if (swatch) {
        openLightbox(swatch.getAttribute('data-full'), swatch.getAttribute('data-title'));
        return;
      }
      var btn = e.target.closest('.bxgy-picker__step-btn');
      if (!btn || btn.disabled) return;
      var row = btn.closest('.bxgy-picker__row');
      var vid = row.getAttribute('data-variant');
      var cur = pickerQty[vid] || 0;
      var cap = (currentState.pickerCap || 0); // the REAL ceiling right now, not tier.freeMeters
      if (btn.getAttribute('data-action') === 'plus') {
        if (pickerTotal() < cap) pickerQty[vid] = cur + 1;
      } else if (cur > 0) {
        pickerQty[vid] = cur - 1;
      }
      renderPicker();
    });

    confirmBtn.addEventListener('click', function () {
      var updates = {};
      Object.keys(pickerQty).forEach(function (vid) { updates[vid] = pickerQty[vid]; });
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Updating…';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          closePicker();
        })
        .catch(function () { window.location.reload(); });
    });

    // Sums whichever discount-amount field the AJAX Cart API response actually
    // carries for this line — `discounts` (legacy, documented) or
    // `line_level_discount_allocations` (mirrors the Liquid line_item object) —
    // matching only allocations whose title contains this reward's label, same
    // contains-match already proven correct for the Order Summary bucketing fix.
    function lineBxgyDiscountAmount(it) {
      var allocs = it.line_level_discount_allocations || it.discounts || [];
      var amt = 0;
      allocs.forEach(function (d) {
        var title = ((d.discount_application && d.discount_application.title) || d.title || '').toString().toUpperCase();
        if (title.indexOf(REWARD_LABEL) === -1) return;
        var a = Number(d.amount);
        if (isFinite(a)) amt += a;
      });
      return amt;
    }

    function refreshFromServer() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).map(function (it) {
            return {
              product_id: it.product_id,
              variant_id: it.variant_id,
              product_type: it.product_type,
              quantity: it.quantity,
              unit_price: it.final_price,
              sku: it.sku,
              bxgy_discount_amount: lineBxgyDiscountAmount(it),
              original_line_price: it.original_line_price
            };
          });
          cartQtyByVariant = {};
          lines.forEach(function (l) { cartQtyByVariant[String(l.variant_id)] = l.quantity || 0; });
          lastLines = lines;
          var state = compute(lines, catMap);
          updatePill(state);
        })
        .catch(function () {});
    }

    lastLines = initialLines;
    var initialState = compute(initialLines, catMap);
    updatePill(initialState);
    document.addEventListener('cart:updated', refreshFromServer);
    document.addEventListener('cart:added', refreshFromServer);

    // assets/cart.js's own cart:updated listener replaces #cart-summary's
    // innerHTML with a fresh server render — racing against
    // refreshFromServer() above (both fire off the SAME event). If that
    // replacement resolves after refreshFromServer already applied the
    // correct values, it wipes them back to the (flawed/blank) Liquid
    // defaults with nothing to repopulate them. Re-apply lastState
    // immediately whenever #cart-summary's children change, regardless of
    // which fetch wins the race — self-heals even if the state is briefly
    // stale (refreshFromServer's own calls correct it moments later once
    // its fetch resolves).
    // 2026-08-13: the equivalent #cart-form observer that used to live here
    // (re-invoking updateLineBadges on every swap) was removed along with
    // that function — cart-line-item.liquid/cart-items-list.liquid now
    // render the "N of M meters FREE" badges directly from real Shopify
    // discount data + the BXGY tier's own configured rate, so there's
    // nothing left for JS to correct after a server render.
    var summaryEl = document.getElementById('cart-summary');
    if (summaryEl && window.MutationObserver) {
      var pillObserver = new MutationObserver(function () {
        if (lastState) updatePill(lastState);
      });
      pillObserver.observe(summaryEl, { childList: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bxgy-progress-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var card = document.getElementById('bxgy-pc');
    if (!card) return;

    var headlineEl = document.getElementById('bxgy-pc-headline');
    var fillEl = document.getElementById('bxgy-pc-fill');
    var cdEl = document.getElementById('bxgy-pc-countdown');
    var wsReqEl = document.getElementById('bxgy-pc-wholesale-required');
    var claimEl = document.getElementById('bxgy-pc-claim');
    var claimTextEl = document.getElementById('bxgy-pc-claim-text');
    var claimBtn = document.getElementById('bxgy-pc-claim-btn');
    var lastBestIndex = -1;
    // Set by render() each pass, read by the countdown's own tick() below —
    // suppresses the countdown re-showing itself on its next 1s tick once the
    // wholesale-required pill has taken over the same top-right slot.
    var suppressCountdown = false;

    function parseJSON(id, fallback) {
      var el = document.getElementById(id);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent) || fallback; } catch (e) { return fallback; }
    }

    var bxgy = parseJSON('bxgy-shared-config-data', null);
    var ladder = parseJSON('bxgy-shared-ladder-data', {}) || {};
    if (!bxgy || !bxgy.tiers || !bxgy.tiers.length) return;

    var tiers = bxgy.tiers.slice().sort(function (a, b) {
      return (a.buyMeters || 0) - (b.buyMeters || 0);
    });

    // 2026-08-13: app-side fix — wholesale-segment tiers are now only
    // actually reachable at checkout for a real wholesale customer (the
    // deployed Function was updated to enforce this). The progress card's
    // own compute() had no segment awareness at all, so it could still
    // point a non-wholesale customer at "Add N more meters, to get Y FREE"
    // for a reward checkout would never actually grant them. Filtered once
    // here, before compute() ever runs, rather than patching each of its
    // two tier-walk loops separately — both already only read from `tiers`.
    var isWholesaleCustomer = card.getAttribute('data-is-wholesale') === 'true';
    // 2026-08-13: kept alongside the filtered `tiers` — used only in the
    // "maxed out every reachable tier" render() branch below, to show what
    // registering for wholesale would unlock AT THE CUSTOMER'S CURRENT cart
    // size specifically (not a vague "add more" preview, which would
    // contradict "you've unlocked our best available reward" — they don't
    // need to add anything, just the account).
    var allTiers = tiers;
    if (!isWholesaleCustomer) {
      tiers = tiers.filter(function (t) { return t.segment !== 'wholesale'; });
    }

    var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
    var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });

    function getMetersPerUnit(sku) {
      if (!sku) return 1;
      var match = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!match) return 1;
      var value = Number(match[1]);
      return isFinite(value) && value > 0 ? value : 1;
    }
    function getEffectiveMeters(line) {
      return (line.quantity || 0) * getMetersPerUnit(line.sku);
    }
    function isBuyEligible(line) {
      if (!eligTypes.length && !eligIds.length) return true;
      var t = String(line.product_type || '').toLowerCase();
      if (eligTypes.indexOf(t) !== -1) return true;
      if (eligIds.indexOf(String(line.product_id)) !== -1) return true;
      return false;
    }
    function fmt(n) {
      n = Math.round(n * 10) / 10;
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    }
    function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
    function tierBenefitText(tier) {
      var free = tier.freeMeters || 0;
      var pct = (tier.rewardDiscountPercent === undefined || tier.rewardDiscountPercent === null) ? 100 : tier.rewardDiscountPercent;
      return (pct >= 100) ? fmt(free) + ' ' + mUnit(free) + ' FREE' : fmt(free) + ' ' + mUnit(free) + ' at ' + pct + '% off';
    }

    function buildRewardLines(lines, catMap, cats) {
      return lines.map(function (l, i) { return { i: i, l: l }; })
        .filter(function (e) {
          var c = catMap[String(e.l.product_id)];
          return c && cats.indexOf(c) !== -1;
        })
        .map(function (e) {
          var m = getMetersPerUnit(e.l.sku);
          return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
        })
        .sort(function (a, b) { return a.perMeter - b.perMeter; });
    }

    // cheapest-per-effective-meter-first, up to capMeters total — "can this tier's
    // full reward be given at all" allocation. Mirrors bxgy-claim-picker.liquid's
    // allocate() exactly, so both cards agree on which tier is currently applying.
    function allocate(lines, catMap, buyEligibleIdx, cats, capMeters) {
      var rewardLines = buildRewardLines(lines, catMap, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var unitsAffordable = Math.floor(remaining / rl.mpu + 1e-9);
        var unitsToFree = Math.min(unitsAffordable, rl.quantity);
        if (unitsToFree <= 0) continue;
        var freed = unitsToFree * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (buyEligibleIdx[rl.i]) dualFreed += freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed };
    }

    // partial-cap allocation: non-dual donors keep being given away free (they cost
    // nothing against the buy total) up to capMeters, but dual-eligible donors stop
    // once their portion hits dualBudget. Mirrors bxgy-claim-picker.liquid's
    // allocateBudgetCapped() exactly.
    function allocateBudgetCapped(lines, catMap, buyEligibleIdx, cats, capMeters, dualBudget) {
      var rewardLines = buildRewardLines(lines, catMap, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var isDual = !!buyEligibleIdx[rl.i];
        var maxByDualBudget = isDual ? Math.floor(Math.max(0, dualBudget - dualFreed) / rl.mpu + 1e-9) : Infinity;
        var unitsAffordable = Math.floor(remaining / rl.mpu + 1e-9);
        var unitsToFree = Math.min(unitsAffordable, rl.quantity, maxByDualBudget);
        if (unitsToFree <= 0) continue;
        var freed = unitsToFree * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (isDual) dualFreed += freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed };
    }

    /*
     * Deliberately decoupled from bxgy-claim-picker.liquid's pill — this card
     * calculates its own target independent of whatever the pill is currently
     * displaying, per explicit instruction. Two parts:
     *
     * 1. Find the tier CURRENTLY applying, same "keep best" walk as the claim pill
     *    (never let climbing make the reward worse — a shortfall tier's capped
     *    partial only replaces a lower tier's already-secured result if it actually
     *    grants MORE meters). `bestFreed` is how many meters are really realized
     *    right now.
     * 2. Target is simply the NEXT configured tier after bestIndex — no scanning,
     *    no re-testing whether it's independently affordable. `need` = that tier's
     *    own raw buyMeters minus (totalBuy minus what's already realized) — i.e.
     *    "how many more meters, on top of what's already paid past the realized
     *    reward, to reach this tier's raw threshold."
     */
    function compute(lines, catMap) {
      var totalBuy = 0;
      var buyEligibleIdx = {};
      lines.forEach(function (l, i) {
        if (isBuyEligible(l)) {
          totalBuy += getEffectiveMeters(l);
          buyEligibleIdx[i] = true;
        }
      });

      // phase 1 — same "keep best" walk as the claim pill, to find where it settles
      var bestFreed = null;
      var bestIndex = -1;
      for (var t = 0; t < tiers.length; t++) {
        var tier = tiers[t];
        var buyMeters = tier.buyMeters || 0;
        if (totalBuy < buyMeters - 1e-9) break;

        var cats = tier.rewardCategories || [];
        var free = tier.freeMeters || 0;
        if (free <= 0 || !cats.length) break;

        var full = allocate(lines, catMap, buyEligibleIdx, cats, free);
        var paid = totalBuy - full.dualFreed;

        if (paid >= buyMeters - 1e-9) {
          bestFreed = full.freed;
          bestIndex = t;
          continue;
        }

        var dualBudget = totalBuy - buyMeters;
        var capped = allocateBudgetCapped(lines, catMap, buyEligibleIdx, cats, free, dualBudget);
        if (bestFreed === null || capped.freed > bestFreed + 1e-9) {
          bestFreed = capped.freed;
          bestIndex = t;
        }
        break;
      }

      // Chain forward past any tier this same simplified formula already treats as
      // met (need <= 0) — "Add 0 more, to get X" is a dead-end message, so keep
      // testing successive tiers against the SAME fixed `realized` baseline until
      // landing on the first one with a genuinely positive need.
      var realized = bestFreed || 0;
      var idx = bestIndex + 1;
      while (idx < tiers.length) {
        var candidate = tiers[idx];
        var needCandidate = (candidate.buyMeters || 0) - (totalBuy - realized);
        if (needCandidate > 1e-9) {
          return { next: candidate, need: needCandidate, rawBuy: totalBuy, bestIndex: bestIndex };
        }
        idx++;
      }
      return { next: null, rawBuy: totalBuy, bestIndex: bestIndex };
    }

    function render(lines) {
      var state = compute(lines, catMap);
      var next = state.next;
      lastBestIndex = state.bestIndex;

      if (!next) {
        // 2026-08-13: `tiers` is already filtered to exclude wholesale-only
        // tiers for a non-wholesale customer (see init above) — so `next`
        // coming back null here means they've genuinely cleared every tier
        // they CAN reach, not that the data ran out. Show the card with the
        // wholesale-required pill repurposed as a "you've maxed out, here's
        // what unlocks more" nudge instead of just hiding — was previously
        // dead code once the filtering above landed (next.segment could
        // never be 'wholesale' for this audience anymore, so it never fired
        // from inside the normal path below). A wholesale customer (or a
        // non-wholesale one with literally zero reachable tiers configured)
        // still just hides, same as before — nothing more to offer either way.
        if (!isWholesaleCustomer && tiers.length > 0 && state.bestIndex >= 0) {
          card.hidden = false;
          headlineEl.innerHTML = 'You’ve unlocked our best available reward';
          // 2026-08-13: show what registering for wholesale would ALSO
          // unlock right now, at this same cart size — walks the
          // unfiltered allTiers (highest tier whose raw threshold the real
          // rawBuy meets, wholesale or not) rather than assuming "the next
          // tier up" would need more meters added, which it doesn't here.
          var wholesaleTier = null;
          for (var wi = allTiers.length - 1; wi >= 0; wi--) {
            if ((state.rawBuy || 0) >= (allTiers[wi].buyMeters || 0)) {
              wholesaleTier = allTiers[wi];
              break;
            }
          }
          if (wholesaleTier && wholesaleTier.segment === 'wholesale') {
            headlineEl.innerHTML += ' — register for wholesale to unlock <span class="bxgy-pc__highlight">' +
              tierBenefitText(wholesaleTier) + '</span>';
          }
          fillEl.style.width = '100%';
          suppressCountdown = true;
          if (cdEl) cdEl.hidden = true;
          if (wsReqEl) wsReqEl.hidden = false;
        } else {
          card.hidden = true;
        }
        updateClaimRow();
        return;
      }

      var buy = state.rawBuy || 0;
      var need = Math.max(0, state.need || 0);
      var requiredRaw = buy + need; // reconstructs the milestone's raw threshold from need
      var pct = requiredRaw > 0 ? (buy / requiredRaw) * 100 : 0;
      if (pct < 0) pct = 0;
      if (pct > 96) pct = 96;

      // `next` is always a tier genuinely beyond whatever the claim pill is already
      // reporting on (see compute()). 2026-08-26: below the very first tier
      // (bestIndex === -1) used to say vague "unlock your first reward" instead
      // of naming it — unified with the normal case, which already names the
      // reward outright ("Add X more meters, to get Y") — more actionable,
      // and this was purely a copy choice, not a technical constraint (`next`
      // was already resolved and available either way).
      headlineEl.innerHTML = 'Add ' + fmt(need) + ' more ' + mUnit(need) + ', to get <span class="bxgy-pc__highlight">' + tierBenefitText(next) + '</span>';
      fillEl.style.width = pct + '%';
      card.hidden = false;
      suppressCountdown = false;
      if (wsReqEl) wsReqEl.hidden = true;
      updateClaimRow();
    }

    function updateClaimRow() {
      if (!claimEl) return;
      var sidebarBtn = document.getElementById('bxgy-claim');
      if (lastBestIndex < 0 || !sidebarBtn || sidebarBtn.getAttribute('data-applied') === 'true') {
        claimEl.hidden = true;
        return;
      }
      var reachedTier = tiers[lastBestIndex];
      if (!reachedTier) {
        claimEl.hidden = true;
        return;
      }
      if (claimTextEl) claimTextEl.textContent = tierBenefitText(reachedTier) + ' unlocked';
      claimEl.hidden = false;
    }

    if (claimBtn) {
      claimBtn.addEventListener('click', function () {
        var sidebarOpenBtn = document.getElementById('bxgy-claim-open');
        if (sidebarOpenBtn) sidebarOpenBtn.click();
      });
    }

    var summaryElForClaim = document.getElementById('cart-summary');
    if (summaryElForClaim && window.MutationObserver) {
      var claimRowObserver = new MutationObserver(function () { updateClaimRow(); });
      claimRowObserver.observe(summaryElForClaim, { attributes: true, subtree: true, attributeFilter: ['data-applied'] });
    }

    // /cart.js line items don't carry the free_gift_category metafield, so live
    // updates reuse the SAME static catMap built once at init (from the initial cart
    // lines' embedded category + the reward-product catalog below) rather than trying
    // to rebuild it — category is a static property of a product, not something that
    // changes between cart snapshots, so this stays accurate across add/remove/qty.
    function refreshFromServer() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).map(function (it) {
            return {
              product_id: it.product_id,
              product_type: it.product_type,
              quantity: it.quantity,
              unit_price: it.final_price,
              sku: it.sku
            };
          });
          render(lines);
        })
        .catch(function () {});
    }

    // countdown, independent of tier progress
    (function () {
      if (!cdEl) return;
      var countdownMode = card.getAttribute('data-countdown-mode') || 'always';
      var isPeak = card.getAttribute('data-is-peak') === 'true';
      if (countdownMode === 'peak_only' && !isPeak) return;
      var validUntilRaw = card.getAttribute('data-valid-until');
      if (!validUntilRaw) return;
      var validUntil = new Date(validUntilRaw);
      if (isNaN(validUntil.getTime())) return;
      var timer = null;
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        if (suppressCountdown) {
          cdEl.hidden = true;
          return;
        }
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) {
          cdEl.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = '⏱ ' + pad(h) + ':' + pad(m) + ':' + pad(s);
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();

    var initialLines = parseJSON('bxgy-pc-cart-lines', []) || [];
    var rewardCatmapSeed = parseJSON('bxgy-pc-reward-catmap', []) || [];

    // static product_id -> category lookup, built once, reused for every render() call
    // (initial and live-refreshed alike) — see refreshFromServer() for why.
    var catMap = {};
    initialLines.forEach(function (l) { if (l.category) catMap[String(l.product_id)] = l.category; });
    rewardCatmapSeed.forEach(function (r) { if (r.category) catMap[String(r.product_id)] = r.category; });

    render(initialLines);
    document.addEventListener('cart:updated', refreshFromServer);
    document.addEventListener('cart:added', refreshFromServer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bxgy-reward-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('bxgy-reward');
    if (!box) return;

    function parseJSON(id, fb) {
      var el = document.getElementById(id);
      if (!el) return fb;
      try { return JSON.parse(el.textContent); } catch (e) { return fb; }
    }

    var tiers = (parseJSON('bxgy-reward-tiers', []) || []).slice().sort(function (a, b) {
      return (a.buyMeters || 0) - (b.buyMeters || 0);
    });
    if (!tiers.length) return;
    var ladder = parseJSON('bxgy-reward-ladder', {}) || {};
    var cartLines = parseJSON('bxgy-reward-cart', []) || [];
    var variants = parseJSON('bxgy-reward-variants', []) || [];

    var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
    var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }
    function fmt(n) {
      n = Math.round(n * 10) / 10;
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    }
    function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
    // full tier reward, priced via that tier's own rewardDiscountPercent (default 100 = free)
    function tierBenefitHtml(t) {
      var free = t.freeMeters || 0;
      var pct = (t.rewardDiscountPercent === undefined || t.rewardDiscountPercent === null) ? 100 : t.rewardDiscountPercent;
      return (pct >= 100) ? fmt(free) + ' free ' + mUnit(free) : fmt(free) + ' ' + mUnit(free) + ' at ' + pct + '% off';
    }

    var pageProduct = parseJSON('bxgy-reward-product', {}) || {};

    var catMap = {};
    cartLines.forEach(function (l) {
      if (l.category) catMap[String(l.product_id)] = l.category;
    });
    if (pageProduct.category) catMap[String(pageProduct.product_id)] = pageProduct.category;

    function isBuyEligible(l) {
      if (!eligTypes.length && !eligIds.length) return true;
      var t = String(l.product_type || '').toLowerCase();
      return eligTypes.indexOf(t) !== -1 || eligIds.indexOf(String(l.product_id)) !== -1;
    }
    function eff(l) { return (l.quantity || 0) * mpu(l.sku); }

    function buildRewardLines(lines, cats) {
      return lines.map(function (l, i) { return { i: i, l: l }; })
        .filter(function (e) {
          var c = catMap[String(e.l.product_id)];
          return c && cats.indexOf(c) !== -1;
        })
        .map(function (e) {
          var m = mpu(e.l.sku);
          return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
        })
        .sort(function (a, b) { return a.perMeter - b.perMeter; });
    }
    // cheapest-per-effective-meter-first, up to capMeters total — "can this tier's
    // full reward be given at all" allocation. Mirrors bxgy-claim-picker.liquid.
    function allocate(lines, buyIdx, cats, capMeters) {
      var rewardLines = buildRewardLines(lines, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var ua = Math.floor(remaining / rl.mpu + 1e-9);
        var uf = Math.min(ua, rl.quantity);
        if (uf <= 0) continue;
        var freed = uf * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (buyIdx[rl.i]) dualFreed += freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed };
    }
    // partial-cap allocation: non-dual donors keep being given away free up to
    // capMeters, dual-eligible donors stop once their portion hits dualBudget.
    function allocateBudgetCapped(lines, buyIdx, cats, capMeters, dualBudget) {
      var rewardLines = buildRewardLines(lines, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var isDual = !!buyIdx[rl.i];
        var maxByDualBudget = isDual ? Math.floor(Math.max(0, dualBudget - dualFreed) / rl.mpu + 1e-9) : Infinity;
        var ua = Math.floor(remaining / rl.mpu + 1e-9);
        var uf = Math.min(ua, rl.quantity, maxByDualBudget);
        if (uf <= 0) continue;
        var freed = uf * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (isDual) dualFreed += freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed };
    }

    /*
     * Matches the deployed Function's "walk ascending + partial cap" algorithm.
     * Two phases, same shape as bxgy-progress-card.liquid (kept in sync with that
     * file's logic — cart-page progress bar — while this card's own UI is unchanged):
     * 1. Walk tiers ascending; a tier that's fully affordable becomes the new
     *    "current best" and climbing continues; a tier that falls short gets a
     *    capped partial, which only replaces a lower tier's already-secured result
     *    if it grants MORE meters (never let climbing make the reward worse) —
     *    either way, stop climbing once a shortfall is hit.
     * 2. Target is simply the NEXT configured tier after bestIndex — no re-testing
     *    whether it's independently affordable. `need` = that tier's own raw
     *    buyMeters minus (totalBuy minus what's already realized), chained forward
     *    past any tier this same simplified formula already treats as met
     *    (need <= 0) so it never shows a dead-end "add 0 more" milestone.
     */
    function compute(lines) {
      var totalBuy = 0;
      var buyIdx = {};
      lines.forEach(function (l, i) {
        if (isBuyEligible(l)) { totalBuy += eff(l); buyIdx[i] = true; }
      });

      var bestTier = null, bestFreed = null, bestIndex = -1;
      for (var t = 0; t < tiers.length; t++) {
        var tier = tiers[t];
        var buyMeters = tier.buyMeters || 0;
        if (totalBuy < buyMeters - 1e-9) break;

        var cats = tier.rewardCategories || [];
        var free = tier.freeMeters || 0;
        if (free <= 0 || !cats.length) break;

        var full = allocate(lines, buyIdx, cats, free);
        var paid = totalBuy - full.dualFreed;

        if (paid >= buyMeters - 1e-9) {
          bestTier = tier;
          bestFreed = full.freed;
          bestIndex = t;
          continue;
        }

        var dualBudget = totalBuy - buyMeters;
        var capped = allocateBudgetCapped(lines, buyIdx, cats, free, dualBudget);
        if (bestFreed === null || capped.freed > bestFreed + 1e-9) {
          bestTier = tier;
          bestFreed = capped.freed;
          bestIndex = t;
        }
        break;
      }

      var next = null, need = 0;
      var realized = bestFreed || 0;
      var idx2 = bestIndex + 1;
      while (idx2 < tiers.length) {
        var candidate2 = tiers[idx2];
        var needCandidate2 = (candidate2.buyMeters || 0) - (totalBuy - realized);
        if (needCandidate2 > 1e-9) {
          next = candidate2;
          need = needCandidate2;
          break;
        }
        idx2++;
      }

      if (!bestTier && !next) return null;
      return { tier: bestTier, free: bestFreed || 0, rawBuy: totalBuy, next: next, need: need, bestIndex: bestIndex };
    }

    var headlineEl = document.getElementById('bxgy-reward-headline');
    var nextEl = document.getElementById('bxgy-reward-next');
    var fillEl = document.getElementById('bxgy-reward-fill');

    // Always forward-pointing: "Add N more meters" / "to get M meters at X% off" —
    // never states what's already in the cart, just the next unlockable reward,
    // whether or not a lower tier has already been earned.
    function render() {
      // Only the REAL cart counts toward the tier math — the page's own qty
      // stepper is never added hypothetically, only after a genuine add-to-cart
      // (which lands in cartLines via the cart:added listener below).
      var allState = compute(cartLines);
      if (!allState) { box.hidden = true; return; }

      var tier = allState.tier;
      var next = allState.next;
      var need = allState.need || 0;
      var buy = allState.rawBuy || 0;

      var headline = '';
      var subtext = '';
      var goal = 0;
      var pct = 0;

      if (next) {
        // 2026-08-26: below-first-tier used to say vague "unlock your first
        // reward" instead of naming it (was allState.bestIndex === -1 as a
        // separate branch) — unified with the normal case below, which
        // already names the reward outright; more actionable, matches
        // every other tier's copy.
        headline = need >= 1
          ? '🎁 Add ' + fmt(need) + ' more ' + mUnit(need)
          : '🎁 Add a few more meters';
        subtext = 'to get ' + tierBenefitHtml(next);
        goal = next.buyMeters || 0;
        pct = goal > 0 ? Math.min(96, (buy / goal) * 100) : 0;
      } else if (tier && (tier.freeMeters || 0) > 0) {
        headline = "🎁 You've unlocked " + tierBenefitHtml(tier) + ' 🎉';
        subtext = '';
        pct = 100;
      } else {
        box.hidden = true;
        return;
      }

      headlineEl.innerHTML = headline;
      nextEl.textContent = subtext;
      fillEl.style.width = pct + '%';
      box.hidden = false;
    }

    // Frozen by design: the target does NOT react to stepper/quantity changes on the
    // page (unlike the design spec's "must recompute live" requirement) — only a real
    // add-to-cart (cart:added) or cart change (cart:updated) refreshes it, so the number
    // stays stable while the customer is still deciding a quantity.
    document.addEventListener('cart:added', function (e) {
      var it = e && e.detail;
      if (!it) return;
      cartLines.push({
        product_id: it.product_id,
        product_type: it.product_type,
        quantity: it.quantity,
        unit_price: it.final_price || it.price || 0,
        sku: it.sku
      });
      render();
    });
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail;
      if (cart && cart.items) {
        cartLines = cart.items.map(function (it) {
          return { product_id: it.product_id, product_type: it.product_type, quantity: it.quantity, unit_price: it.final_price, sku: it.sku };
        });
      }
      render();
    });

    render();

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // two layers of control: this block's own "Show countdown timer" checkbox (manual
    // override, checked first) AND the global "always"/"peak_only" theme setting.
    (function () {
      var cdEl = document.getElementById('bxgy-reward-countdown');
      var raw = box.getAttribute('data-valid-until');
      var blockEnabled = box.getAttribute('data-block-countdown') !== 'false';
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (!blockEnabled) { cdEl.hidden = true; return; }
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = '⏱ ' + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bxgy-teaser"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('bxgy-teaser');
    var promoMsg = box ? (box.getAttribute('data-promo') || '').trim() : '';
    if (!box) return;

    function parseJSON(id, fb) {
      var el = document.getElementById(id);
      if (!el) return fb;
      try { return JSON.parse(el.textContent); } catch (e) { return fb; }
    }

    var tiers = (parseJSON('bxgy-teaser-tiers', []) || []).slice().sort(function (a, b) {
      return (a.buyMeters || 0) - (b.buyMeters || 0);
    });
    if (!tiers.length) return;
    var ladder = parseJSON('bxgy-teaser-ladder', {}) || {};
    var cartLines = parseJSON('bxgy-teaser-cart', []) || [];
    var variants = parseJSON('bxgy-teaser-variants', []) || [];

    var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
    var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }
    function fmt(n) {
      n = Math.round(n * 10) / 10;
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    }
    function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
    // full tier reward, priced via that tier's own rewardDiscountPercent (default 100 = free)
    function tierBenefitHtml(t) {
      var free = t.freeMeters || 0;
      var pct = (t.rewardDiscountPercent === undefined || t.rewardDiscountPercent === null) ? 100 : t.rewardDiscountPercent;
      return (pct >= 100) ? fmt(free) + ' free ' + mUnit(free) : fmt(free) + ' ' + mUnit(free) + ' at ' + pct + '% off';
    }

    var pageProduct = parseJSON('bxgy-teaser-product', {}) || {};

    // product_id -> free_gift_category, seeded from cart + this product
    var catMap = {};
    cartLines.forEach(function (l) {
      if (l.category) catMap[String(l.product_id)] = l.category;
    });
    if (pageProduct.category) catMap[String(pageProduct.product_id)] = pageProduct.category;

    function isBuyEligible(l) {
      if (!eligTypes.length && !eligIds.length) return true;
      var t = String(l.product_type || '').toLowerCase();
      return eligTypes.indexOf(t) !== -1 || eligIds.indexOf(String(l.product_id)) !== -1;
    }
    function eff(l) { return (l.quantity || 0) * mpu(l.sku); }

    function buildRewardLines(lines, cats) {
      return lines.map(function (l, i) { return { i: i, l: l }; })
        .filter(function (e) {
          var c = catMap[String(e.l.product_id)];
          return c && cats.indexOf(c) !== -1;
        })
        .map(function (e) {
          var m = mpu(e.l.sku);
          return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
        })
        .sort(function (a, b) { return a.perMeter - b.perMeter; });
    }
    // cheapest-per-effective-meter-first, up to capMeters total — "can this tier's
    // full reward be given at all" allocation. Mirrors bxgy-claim-picker.liquid.
    function allocate(lines, buyIdx, cats, capMeters) {
      var rewardLines = buildRewardLines(lines, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var ua = Math.floor(remaining / rl.mpu + 1e-9);
        var uf = Math.min(ua, rl.quantity);
        if (uf <= 0) continue;
        var freed = uf * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (buyIdx[rl.i]) dualFreed += freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed };
    }
    // partial-cap allocation: non-dual donors keep being given away free up to
    // capMeters, dual-eligible donors stop once their portion hits dualBudget.
    function allocateBudgetCapped(lines, buyIdx, cats, capMeters, dualBudget) {
      var rewardLines = buildRewardLines(lines, cats);
      var remaining = capMeters;
      var dualFreed = 0, freedTotal = 0;
      for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
        var rl = rewardLines[r];
        var isDual = !!buyIdx[rl.i];
        var maxByDualBudget = isDual ? Math.floor(Math.max(0, dualBudget - dualFreed) / rl.mpu + 1e-9) : Infinity;
        var ua = Math.floor(remaining / rl.mpu + 1e-9);
        var uf = Math.min(ua, rl.quantity, maxByDualBudget);
        if (uf <= 0) continue;
        var freed = uf * rl.mpu;
        remaining -= freed;
        freedTotal += freed;
        if (isDual) dualFreed += freed;
      }
      return { freed: freedTotal, dualFreed: dualFreed };
    }

    /*
     * Matches the deployed Function's "walk ascending + partial cap" algorithm
     * (2026-07-31 backend change — replaces the old highest-to-lowest cascade this
     * teaser previously ran). Two phases, same shape as bxgy-progress-card.liquid:
     * 1. Walk tiers ascending; a tier that's fully affordable becomes the new
     *    "current best" and climbing continues; a tier that falls short gets a
     *    capped partial, which only replaces a lower tier's already-secured result
     *    if it grants MORE meters (never let climbing make the reward worse) —
     *    either way, stop climbing once a shortfall is hit.
     * 2. Scan forward from the best tier found for the next genuinely-unmet
     *    milestone, using the full dual-aware formula (buyMeters + dualFreed -
     *    totalBuy) — no raw-threshold-only shortcut.
     */
    function compute(lines) {
      var totalBuy = 0;
      var buyIdx = {};
      lines.forEach(function (l, i) {
        if (isBuyEligible(l)) { totalBuy += eff(l); buyIdx[i] = true; }
      });

      var bestTier = null, bestFreed = null, bestIndex = -1;
      for (var t = 0; t < tiers.length; t++) {
        var tier = tiers[t];
        var buyMeters = tier.buyMeters || 0;
        if (totalBuy < buyMeters - 1e-9) break;

        var cats = tier.rewardCategories || [];
        var free = tier.freeMeters || 0;
        if (free <= 0 || !cats.length) break;

        var full = allocate(lines, buyIdx, cats, free);
        var paid = totalBuy - full.dualFreed;

        if (paid >= buyMeters - 1e-9) {
          bestTier = tier;
          bestFreed = full.freed;
          bestIndex = t;
          continue;
        }

        var dualBudget = totalBuy - buyMeters;
        var capped = allocateBudgetCapped(lines, buyIdx, cats, free, dualBudget);
        if (bestFreed === null || capped.freed > bestFreed + 1e-9) {
          bestTier = tier;
          bestFreed = capped.freed;
          bestIndex = t;
        }
        break;
      }

      var next = null, need = 0;
      var startIndex = bestIndex >= 0 ? bestIndex + 1 : 0;
      for (var t2 = startIndex; t2 < tiers.length; t2++) {
        var tier2 = tiers[t2];
        var buyMeters2 = tier2.buyMeters || 0;
        var cats2 = tier2.rewardCategories || [];
        var free2 = tier2.freeMeters || 0;
        var dualFreed2 = allocate(lines, buyIdx, cats2, free2).dualFreed;
        var paid2 = totalBuy - dualFreed2;
        if (paid2 >= buyMeters2 - 1e-9) continue;
        next = tier2;
        need = buyMeters2 + dualFreed2 - totalBuy;
        break;
      }

      if (!bestTier && !next) return null;
      return { tier: bestTier, free: bestFreed || 0, rawBuy: totalBuy, next: next, need: need, bestIndex: bestIndex };
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(inp.value)) return variants[i];
      }
      return null;
    }

    function pageQty() {
      var mi = document.getElementById('meter-input');
      var q = mi ? parseInt(mi.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    var textEl = document.getElementById('bxgy-teaser-text');
    var fillEl = document.getElementById('bxgy-teaser-fill');

    function render() {
      var v = currentVariant();
      var pageLine = {
        product_id: pageProduct.product_id,
        product_type: pageProduct.product_type,
        quantity: pageQty(),
        unit_price: v ? (v.price || 0) : 0,
        sku: v ? (v.sku || '') : ''
      };

      var allState = compute(cartLines.concat([pageLine]));
      var cartState = compute(cartLines);

      var nextEl = document.getElementById('bxgy-teaser-next');
      var html = '';
      var nextHtml = '';

      if (!allState) { box.hidden = true; return; }

      var tier = allState.tier;
      var next = allState.next;
      var need = allState.need || 0;
      var buy = allState.rawBuy || 0;

      if (tier && (tier.freeMeters || 0) > 0) {
        // "earned" only when the cart ALONE already secures this tier (corrected calc)
        var earned = cartState && cartState.tier && (cartState.tier.buyMeters || 0) >= (tier.buyMeters || 0);
        var cta = earned ? ' — <a href="/cart">claim it in cart</a>' : ' — add to cart to claim';
        // promoMessage describes today's BASE tier only — once a tier is earned it stops
        // matching the customer's real position, so use computed tier-accurate text instead.
        var earnBit = '<strong>' + tierBenefitHtml(tier) + '</strong>';
        html = (earned ? "You've earned " : 'This order unlocks ') + earnBit + cta;
        if (next) {
          var nextBenefit = tierBenefitHtml(next);
          if (need >= 1) {
            nextHtml = 'Add <strong>' + fmt(need) + ' more ' + mUnit(need) + '</strong> to get <strong>' +
              nextBenefit + '</strong> in total';
          } else {
            nextHtml = 'Add a few more meters to get <strong>' + nextBenefit + '</strong> in total';
          }
        }
      } else if (next) {
        // 2026-08-26: nothing earned yet, but the reward itself is named
        // directly now (was vague "unlock your first reward" before) —
        // more actionable, matches how every other tier's copy already
        // states its reward outright.
        html = (promoMsg ? promoMsg + ' — ' : '') + fmt(buy) + ' / ' + fmt(next.buyMeters) + ' meters, add <strong>' +
          fmt(need) + ' more ' + mUnit(need) + '</strong> to get <strong>' + tierBenefitHtml(next) + '</strong>';
      } else {
        box.hidden = true;
        return;
      }

      textEl.innerHTML = html;
      if (nextEl) {
        nextEl.innerHTML = nextHtml;
        nextEl.hidden = !nextHtml;
      }
      var goal = next ? next.buyMeters : (tier ? tier.buyMeters : 0);
      var pct = goal > 0 ? (buy / goal) * 100 : 100;
      if (next && pct > 96) pct = 96;
      if (pct > 100) pct = 100;
      fillEl.style.width = pct + '%';
      box.hidden = false;
    }

    // live with the page: qty stepper, variant switch, and cart updates when available
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'meter-input' || e.target.name === 'id')) render();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#qty-minus, #qty-plus')) setTimeout(render, 0);
    });
    document.addEventListener('cart:added', function (e) {
      var it = e && e.detail;
      if (!it) return;
      cartLines.push({
        product_id: it.product_id,
        product_type: it.product_type,
        quantity: it.quantity,
        unit_price: it.final_price || it.price || 0,
        sku: it.sku
      });
      render();
    });
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail;
      if (cart && cart.items) {
        cartLines = cart.items.map(function (it) {
          return { product_id: it.product_id, product_type: it.product_type, quantity: it.quantity, unit_price: it.final_price, sku: it.sku };
        });
      }
      render();
    });

    render();

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // merchant control: "always" or "peak_only" (only when bxgy_config.isPeak is true)
    (function () {
      var cdEl = document.getElementById('bxgy-teaser-countdown');
      var raw = box.getAttribute('data-valid-until');
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = 'Ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-added-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartAdded) return;

    var toast = document.getElementById('cart-toast');
    var imgEl = document.getElementById('cart-toast-img');
    var titleEl = document.getElementById('cart-toast-title');
    var hideTimer = null;

    function syncCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var els = document.querySelectorAll('.header__cart-count, [data-cart-count]');
          els.forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
            el.classList.remove('is-bumped');
            void el.offsetWidth;
            el.classList.add('is-bumped');
          });
        })
        .catch(function () {});
    }

    function show(item) {
      if (!toast) { syncCount(); return; }
      if (item) {
        var img = item.image || item.featured_image || (item.featured_image && item.featured_image.url) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var itemTitle = item.product_title || item.title || 'Item';
        if (img) { imgEl.src = img.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1'); imgEl.alt = itemTitle; imgEl.style.display = ''; }
        else { imgEl.style.display = 'none'; }
        titleEl.textContent = itemTitle;
      }
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 3200);
      syncCount();
    }

    function hide() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }

    // Unified add-to-cart hook — every add path calls this.
    window.__cartAdded = show;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    function __initCartDrawer() {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    var el = document.getElementById('cart-drawer');
    if (!el) return;

    var body = document.getElementById('cd-body');
    var itemsWrap = document.getElementById('cd-items');
    var emptyEl = document.getElementById('cd-empty');
    var footerEl = document.getElementById('cd-footer');
    var countEl = document.getElementById('cd-count');
    var subtotalEl = document.getElementById('cd-subtotal');
    var savingsEl = document.getElementById('cd-savings');
    var shipMsg = document.getElementById('cd-ship-msg');
    var shipFill = document.getElementById('cd-ship-fill');
    var shipBar = document.getElementById('cd-ship-bar');
    var upsellWrap = document.getElementById('cd-upsell');
    var upsellScroll = document.getElementById('cd-upsell-scroll');
    var scrollHint = document.getElementById('cd-scroll-hint');
    var scrollHintText = document.getElementById('cd-scroll-hint-text');
    var scrollSections = document.getElementById('cd-scroll-sections');
    var discountToggle = document.getElementById('cd-discount-toggle');
    var discountForm = document.getElementById('cd-discount-form');
    var discountInput = document.getElementById('cd-discount-input');
    var discountApply = document.getElementById('cd-discount-apply');
    var discountMsg = document.getElementById('cd-discount-msg');
    var discountWrap = document.getElementById('cd-discount');

    var popup = document.getElementById('cd-remove-popup');
    var popupImg = document.getElementById('cd-popup-img');
    var popupTitle = document.getElementById('cd-popup-title');
    var popupWishlist = document.getElementById('cd-popup-wishlist');
    var popupRemove = document.getElementById('cd-popup-remove');
    var pendingRemoveKey = null;
    var pendingRemoveHandle = null;

    var FREE_SHIP_THRESHOLD = 99900;
    var debounceTimer = null;
    var cartCache = null;

    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Pull the same server-rendered line items the cart page uses, so the two can't drift.
    function renderSharedItems() {
      var params = new URLSearchParams(window.location.search);
      params.set('section_id', 'cart-items');
      fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rendered = doc.getElementById('cart-items-render');
          if (rendered) itemsWrap.innerHTML = rendered.innerHTML;
        })
        .catch(function() {});
    }

    // cart-items.js performs line-item mutations and fires this; only re-render if we're open.
    document.addEventListener('cart:updated', function(e) {
      if (el && el.classList.contains('is-open')) renderItems(e.detail);
    });

    function open() {
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }

    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showRemovePopup(key, title, imgSrc, handle) {
      pendingRemoveKey = key;
      pendingRemoveHandle = handle;
      popupTitle.textContent = title;
      popupImg.src = imgSrc || '';
      popupImg.alt = title || '';
      popup.style.display = '';
      requestAnimationFrame(function() {
        popup.classList.add('is-visible');
      });
    }

    function hideRemovePopup() {
      popup.classList.remove('is-visible');
      setTimeout(function() { popup.style.display = 'none'; }, 200);
      pendingRemoveKey = null;
      pendingRemoveHandle = null;
    }

    function updateShipBar(total) {
      if (FREE_SHIP_THRESHOLD <= 0) { shipBar.style.display = 'none'; return; }
      var remaining = FREE_SHIP_THRESHOLD - total;
      var pct = Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100);
      shipFill.style.width = pct + '%';
      if (remaining <= 0) {
        shipMsg.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> You qualify for <strong style="color:var(--color-gold)">free shipping!</strong>';
        shipFill.classList.add('is-complete');
      } else {
        shipMsg.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--color-gold)" stroke-width="1.5"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8l5 3-5 3V8z"/></svg> Add <strong style="color:var(--color-gold)">' + formatMoney(remaining) + '</strong> more for free shipping';
        shipFill.classList.remove('is-complete');
      }
    }

    function renderItems(cart) {
      cartCache = cart;
      countEl.textContent = '(' + cart.item_count + ')';

      var headerCount = document.querySelector('.header__cart-count');
      if (headerCount) {
        headerCount.textContent = cart.item_count;
        headerCount.style.display = cart.item_count > 0 ? '' : 'none';
      }

      if (cart.item_count === 0) {
        itemsWrap.innerHTML = '';
        emptyEl.style.display = '';
        footerEl.style.display = 'none';
        if (scrollSections) scrollSections.style.display = 'none';
        if (scrollHint) scrollHint.style.display = 'none';
        return;
      }

      emptyEl.style.display = 'none';
      footerEl.style.display = '';
      if (scrollSections) scrollSections.style.display = '';
      shipBar.style.display = '';

      var totalSavings = 0;
      cart.items.forEach(function(item) {
        if (item.original_line_price > item.final_line_price) {
          totalSavings += item.original_line_price - item.final_line_price;
        }
      });

      // Render the SAME server-side markup the cart page uses, so the drawer can never
      // drift from it (grouping, cut notes, free-item styling, stock caps all come free).
      renderSharedItems();

      subtotalEl.textContent = formatMoney(cart.total_price);
      updateShipBar(cart.total_price);

      if (totalSavings > 0) {
        savingsEl.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><path d="M7 7h.01"/></svg> You save ' + formatMoney(totalSavings);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }

      updateDiscountPills(cart);
      updateScrollHint(cart);
      fetchUpsells(cart);
    }

    function refreshCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(renderItems)
        .catch(function() {});
    }

    function updateQty(key, qty) {
      var updates = {};
      updates[key] = qty;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) { renderItems(cart); });
    }

    function updateDiscountPills(cart) {
      var discounts = cart.cart_level_discount_applications || [];
      var toggleText = 'Have a discount code?';
      if (discounts.length) {
        var pillsHtml = '<div class="cart-drawer__discount-pills">';
        discounts.forEach(function(d) {
          pillsHtml += '<span class="cd-discount-pill">' + d.title + ' −' + formatMoney(d.total_allocated_amount) + '</span>';
        });
        pillsHtml += '</div>';
        var existing = discountWrap.querySelector('.cart-drawer__discount-pills');
        if (existing) existing.remove();
        discountToggle.insertAdjacentHTML('beforebegin', pillsHtml);
        toggleText = 'Add another code';
      } else {
        var existing = discountWrap.querySelector('.cart-drawer__discount-pills');
        if (existing) existing.remove();
      }
      discountToggle.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><path d="M7 7h.01"/></svg> ' + toggleText;
    }

    function updateScrollHint(cart) {
      if (!scrollHint) return;
      var totalItems = cart.items.length;
      if (totalItems > 3 && body.scrollTop < 20) {
        var hidden = totalItems - 2;
        scrollHintText.textContent = 'Scroll for ' + hidden + ' more ' + (hidden === 1 ? 'item' : 'items');
        scrollHint.style.display = '';
      } else {
        scrollHint.style.display = 'none';
      }
    }

    if (body) {
      body.addEventListener('scroll', function() {
        if (scrollHint && body.scrollTop > 30) {
          scrollHint.style.display = 'none';
        }
      }, { passive: true });
    }

    function fetchUpsells(cart) {
      if (!cart.items.length) { upsellWrap.style.display = 'none'; return; }
      fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=6&intent=related')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.products || [];
          var cartHandles = {};
          cart.items.forEach(function(i) { cartHandles[i.handle] = true; });
          products = products.filter(function(p) { return !cartHandles[p.handle] && p.available; });
          if (!products.length) { upsellWrap.style.display = 'none'; return; }
          upsellWrap.style.display = '';
          var html = '';
          products.slice(0, 5).forEach(function(p) {
            var img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';
            var price = formatMoney(p.price);
            var altText = (p.title || '').replace(/"/g, '&quot;');
            html += '<button type="button" class="cd-upsell-card" data-cd-upsell-qv="' + p.handle + '" data-cd-upsell-img="' + img + '">';
            html += '<img class="cd-upsell-card__img" src="' + img + '" alt="' + altText + '" loading="lazy">';
            html += '<p class="cd-upsell-card__name">' + p.title + '</p>';
            html += '<p class="cd-upsell-card__price">' + price + '</p>';
            html += '</button>';
          });
          upsellScroll.innerHTML = html;
        })
        .catch(function() { upsellWrap.style.display = 'none'; });
    }

    el.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        close();
        return;
      }

      var removeBtn = e.target.closest('[data-cd-remove]');
      if (removeBtn) {
        var key = removeBtn.dataset.cdRemove;
        var row = removeBtn.closest('.cd-item');
        var title = row ? row.dataset.title : '';
        var imgSrc = row ? row.dataset.img : '';
        var handle = row ? row.dataset.handle : '';
        showRemovePopup(key, title, imgSrc, handle);
        return;
      }

      var upsellCard = e.target.closest('[data-cd-upsell-qv]');
      if (upsellCard) {
        var handle = upsellCard.dataset.cdUpsellQv;
        var img = upsellCard.dataset.cdUpsellImg || '';
        if (window.__qvOpen) window.__qvOpen(handle, img);
        return;
      }

      var qtyBtn = e.target.closest('[data-cd-qty]');
      if (qtyBtn) {
        var action = qtyBtn.dataset.cdQty;
        var key = qtyBtn.dataset.cdKey;
        var val = qtyBtn.closest('.cd-item__qty').querySelector('.cd-item__qty-val');
        var cur = parseInt(val.textContent) || 1;
        var newQty = action === 'plus' ? cur + 1 : Math.max(0, cur - 1);
        if (newQty === 0) {
          var row = qtyBtn.closest('.cd-item');
          var title = row ? row.dataset.title : '';
          var imgSrc = row ? row.dataset.img : '';
          var handle = row ? row.dataset.handle : '';
          showRemovePopup(key, title, imgSrc, handle);
          return;
        }
        val.textContent = newQty;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          updateQty(key, newQty);
        }, 350);
        return;
      }
    });

    if (popup) {
      popup.addEventListener('click', function(e) {
        if (e.target.closest('[data-cd-popup-close]')) {
          hideRemovePopup();
          return;
        }
      });

      popupRemove.addEventListener('click', function() {
        if (!pendingRemoveKey) return;
        var key = pendingRemoveKey;
        hideRemovePopup();
        var row = document.querySelector('.cd-item[data-key="' + key + '"]');
        if (row) row.classList.add('is-removing');
        updateQty(key, 0);
      });

      popupWishlist.addEventListener('click', function() {
        if (!pendingRemoveKey || !pendingRemoveHandle) return;
        var key = pendingRemoveKey;
        var handle = pendingRemoveHandle;
        var wlData = {
          handle: handle,
          title: popupTitle ? popupTitle.textContent : '',
          image: popupImg ? popupImg.src : ''
        };
        hideRemovePopup();
        if (window.__wl && typeof window.__wl.add === 'function') {
          window.__wl.add(wlData);
        } else {
          var wl = [];
          try { wl = JSON.parse(localStorage.getItem('fvs_wishlist') || '[]'); } catch(ex) {}
          var exists = wl.some(function(w) { return w && w.handle === handle; });
          if (!exists) {
            wl.push(wlData);
            localStorage.setItem('fvs_wishlist', JSON.stringify(wl));
          }
          var wlCount = document.querySelector('[data-wishlist-count]');
          if (wlCount) wlCount.textContent = wl.length;
        }
        var row = document.querySelector('.cd-item[data-key="' + key + '"]');
        if (row) row.classList.add('is-removing');
        updateQty(key, 0);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (popup && popup.style.display !== 'none') { hideRemovePopup(); return; }
        if (el.classList.contains('is-open')) close();
      }
    });

    window.__cartDrawerOpen = open;
    window.__cartDrawerClose = close;
    window.__cartDrawerRefresh = refreshCart;
    // Unified add hook — in drawer mode, adding opens the drawer.
    window.__cartAdded = function() { open(); };

    document.addEventListener('cart:added', function() {
      open();
    });

    if (discountToggle && discountForm) {
      discountToggle.addEventListener('click', function() {
        var showing = discountForm.style.display !== 'none';
        discountForm.style.display = showing ? 'none' : '';
        if (!showing) discountInput.focus();
      });
    }

    if (discountApply && discountInput) {
      function applyDiscount() {
        var code = discountInput.value.trim();
        if (!code) return;
        discountApply.textContent = '...';
        sessionStorage.setItem('fvs_discount_attempt', code);
        close();
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      }
      discountApply.addEventListener('click', applyDiscount);
      discountInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
      });
    }
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__initCartDrawer);
  } else {
    document.addEventListener('DOMContentLoaded', __initCartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-rewards-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // One-time count on load — covers LOYALTY/PREPAID (Liquid-rendered,
    // correct from first paint, never needs a live re-count). BXGY's row can
    // still be hidden at this point pending its own JS eligibility check —
    // bxgy-claim-picker.liquid's recountRewardsCount() re-syncs the text
    // right after that resolves, when that file is even rendered.
    var countEl = document.getElementById('cart-rewards-count');
    if (countEl) {
      var rows = document.querySelectorAll('#cart-rewards .cart-reward-row:not([hidden])');
      var left = 0;
      rows.forEach(function (row) {
        if (row.getAttribute('data-applied') !== 'true') left++;
      });
      countEl.textContent = left > 0 ? left + ' to claim' : 'All claimed';
    }

    // 2026-08-12: active visibility safety net. Card show/hide is declared
    // via the CSS :has() rule above, but the card was reported going fully
    // blank after ANY cart mutation (quantity change, discount apply,
    // discount remove — anything that triggers assets/cart.js's
    // refreshSection(), which replaces #cart-summary's innerHTML with a
    // fresh server render) and only recovering on a full page reload — a
    // symptom pattern consistent with something client-side failing to
    // re-settle after the swap, not a Liquid rendering problem (Order
    // Summary right below this card, in the SAME swapped innerHTML,
    // continued updating correctly). Root cause not conclusively isolated
    // (no dev-tools access to the failing state to confirm), so this JS
    // check re-asserts the correct visibility directly via inline
    // style.display (which wins over the CSS selector by specificity)
    // rather than depending solely on live :has() re-evaluation — a
    // defensive fix that corrects the symptom regardless of the exact
    // underlying mechanism.
    //
    // This file always renders (unlike bxgy-claim-picker.liquid, gated
    // behind settings.show_bxgy_banner), so this is the one place an
    // unconditional #cart-summary observer can live and still work when
    // BXGY is disabled. requestAnimationFrame defers the check to the next
    // paint — runs AFTER any same-tick synchronous work from
    // bxgy-claim-picker.liquid's own separate MutationObserver (which sets
    // #bxgy-claim's hidden state), regardless of which observer's callback
    // the browser happens to invoke first for the same mutation.
    function recomputeCardVisibility() {
      var cardEl = document.getElementById('cart-rewards');
      if (!cardEl) return;
      var hasVisibleRow = !!document.querySelector(
        '#cart-rewards .cart-reward-row:not([hidden]), #cart-rewards .cart-perk-row'
      );
      cardEl.style.display = hasVisibleRow ? '' : 'none';
    }
    recomputeCardVisibility();

    var summaryEl = document.getElementById('cart-summary');
    if (summaryEl && window.MutationObserver) {
      var cardVisibilityObserver = new MutationObserver(function () {
        requestAnimationFrame(recomputeCardVisibility);
      });
      cardVisibilityObserver.observe(summaryEl, { childList: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ladder-pricing-v2"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('lp2');
    if (!box) return;

    var t2 = parseFloat(box.dataset.t2) || 0;
    var t3 = parseFloat(box.dataset.t3) || 0;
    var min3 = parseInt(box.dataset.min3, 10) || 3;

    // 2026-08-15: only present in the DOM for guests (see the Liquid
    // condition on data-li-t2/data-li-t3 above) — 0 here for anyone else,
    // harmless since signinEl won't exist for them either.
    var liT2 = parseFloat(box.dataset.liT2) || 0;
    var liT3 = parseFloat(box.dataset.liT3) || 0;
    // 2026-08-26: recent-buyer's rate — a guest doesn't know in advance
    // whether they'd land as plain logged-in or recent-buyer once signed
    // in, so the eligibility check below considers whichever of the two
    // is actually better, not just logged-in alone.
    var rbT2 = parseFloat(box.dataset.rbT2) || 0;
    var rbT3 = parseFloat(box.dataset.rbT3) || 0;
    var signinEl = document.getElementById('lp2-signin');
    var signinTitleEl = document.getElementById('lp2-signin-title');
    var signinSubEl = document.getElementById('lp2-signin-sub');

    function variantData() {
      var el = document.getElementById('lp2-variants');
      if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
      return [];
    }

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      var vs = variantData();
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(inp.value)) return vs[i];
      }
      return null;
    }

    function money(sub) {
      return '₹' + Math.round(sub / 100).toLocaleString('en-IN');
    }

    function rateFor(qty, base) {
      if (qty >= min3) return Math.round(base * (100 - t3) / 100);
      if (qty === 2) return Math.round(base * (100 - t2) / 100);
      return base;
    }

    // "price for 1 meter" reference: the CURRENT variant if it's already whole-meter,
    // else the cheapest^H^H first whole-meter sibling in its own fabric group (same
    // option1+option2) — NOT just the first whole-meter variant anywhere on the
    // product, which broke row prices whenever a product has multiple fabric groups
    // at different price points (e.g. switching Japan Satin ₹319 -> Pashmina ₹329
    // kept showing ₹319, because it always grabbed whichever group listed first).
    function baseVariant(v) {
      if (v && v.price && mpu(v.sku) === 1) return v;
      var vs = variantData();
      if (v) {
        var key = groupKey(v);
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].price && mpu(vs[i].sku) === 1 && groupKey(vs[i]) === key) return vs[i];
        }
      }
      for (var j = 0; j < vs.length; j++) {
        if (vs[j].price && mpu(vs[j].sku) === 1) return vs[j];
      }
      return null;
    }

    // width siblings: same fabric (option1+option2), differ only by width (option3) —
    // same grouping key the variant selector (vsv2) uses
    function groupKey(v) {
      return (v.option1 || '') + '|||' + (v.option2 || '');
    }
    // metafield first, option3 as fallback — same chain the variant selector uses
    // (wv.width || wv.option3); metafield-only missed products that carry width as
    // a plain variant option instead of a custom.width metafield.
    function widthOf(v) {
      return (v && (v.width || v.option3)) || '';
    }
    function widthGroup(v) {
      var vs = variantData();
      var key = groupKey(v);
      return vs.filter(function (o) {
        return groupKey(o) === key && mpu(o.sku) === 1 && widthOf(o);
      });
    }

    var specEl = document.getElementById('lp2-spec');
    var qualityEl = document.getElementById('lp2-quality');
    var fabricEl = document.getElementById('lp2-fabric');
    var widthsEl = document.getElementById('lp2-widths');

    function switchToVariant(vid) {
      // delegate to the variant selector's own width chip when present — it owns
      // price/image/URL/ATC-label updates that this card doesn't duplicate
      var vsChip = document.querySelector('.vsv2__width-chip[data-variant-id="' + vid + '"]');
      if (vsChip) { vsChip.click(); return; }
      // fallback (no variant selector on the page): switch the input directly —
      // updates this card and other v2 components, but not price/image/URL
      var inp = document.getElementById('variant-id');
      if (!inp) return;
      inp.value = vid;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function render() {
      // 2026-08-26: while a Quantity Calculator submission is resolving a
      // fractional length (product.js sets this right before it awaits the
      // backend shadow-variant call), that same flow's own applyMapped()
      // internally forces #meter-input back to "1" and clears the pending
      // length as a normal side effect of preparing the real cart-add — a
      // stray "change" event fires off that, and without this guard render()
      // would react to it with a false "quantity=1, nothing pending"
      // snapshot of a form that's actually mid-submit for the real
      // fractional amount, visibly corrupting this card's state right after
      // a successful fractional add. Skip entirely while that's in flight;
      // the flag clears the moment the flow actually finishes either way.
      var qcForm = document.getElementById('product-form');
      if (qcForm && qcForm.dataset.qtyCalcSubmitting === 'true') return;

      var v = currentVariant();
      var bv = baseVariant(v);
      if (!v || !bv) { box.hidden = true; return; }

      var pieceMpu = mpu(v.sku);
      var fractional = pieceMpu !== 1;
      box.classList.toggle('lp2--readonly', fractional);

      if (qualityEl) {
        var q = (v.quality || '').trim();
        qualityEl.textContent = q.toUpperCase();
        qualityEl.hidden = !q;
      }
      if (fabricEl && v.fabric) fabricEl.textContent = v.fabric;

      // dedupe by unique width VALUE, not variant count — a group with 2 variants
      // sharing the same option3/width text (e.g. a duplicate SKU) must still count
      // as one width, not trigger a two-button row that looks identical
      var grp = widthGroup(v);
      var uniqueByWidth = {};
      var uniqueWidths = [];
      grp.forEach(function (wv) {
        var w = widthOf(wv);
        if (!(w in uniqueByWidth)) {
          uniqueByWidth[w] = wv;
          uniqueWidths.push(wv);
        } else if (String(wv.id) === String(v.id)) {
          // keep the currently-selected variant's own id as the representative
          // for its width, so the active pill matches the real selection
          var idx = uniqueWidths.indexOf(uniqueByWidth[w]);
          uniqueByWidth[w] = wv;
          if (idx !== -1) uniqueWidths[idx] = wv;
        }
      });

      if (widthsEl) {
        if (uniqueWidths.length > 1) {
          widthsEl.innerHTML = '<span class="lp2__widths-label">Width:</span>';
          uniqueWidths.forEach(function (wv) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'lp2__width-chip' + (String(wv.id) === String(v.id) ? ' is-active' : '');
            chip.textContent = widthOf(wv);
            chip.addEventListener('click', function () { switchToVariant(wv.id); });
            widthsEl.appendChild(chip);
          });
          widthsEl.hidden = false;
        } else {
          widthsEl.hidden = true;
        }
      }

      if (specEl) {
        var parts = [];
        if (v.sku && v.sku.indexOf('SHADOW') === -1) parts.push(v.sku);
        if (v.gsm) parts.push(v.gsm + ' GSM');
        if (uniqueWidths.length <= 1 && widthOf(v)) parts.push(widthOf(v));
        specEl.textContent = parts.join(' · ');
      }

      var base = bv.price;
      var p1 = box.querySelector('[data-lp-price="1"]');
      var p2 = box.querySelector('[data-lp-price="2"]');
      var p3 = box.querySelector('[data-lp-price="3"]');
      if (p1) p1.innerHTML = money(base) + '<small>/m</small>';
      if (p2) p2.innerHTML = money(rateFor(2, base)) + '<small>/m</small>';
      if (p3) p3.innerHTML = money(rateFor(min3, base)) + '<small>/m</small>';

      var s2 = box.querySelector('[data-lp-save="2"]');
      var s3 = box.querySelector('[data-lp-save="3"]');
      if (s2) s2.textContent = t2 + '% off';
      if (s3) s3.textContent = t3 + '% off';

      var mi = document.getElementById('meter-input');
      var qty = mi ? (parseInt(mi.value, 10) || 1) : 1;
      var form = document.getElementById('product-form');
      var pending = form ? parseFloat(form.dataset.qtyPresetPendingMeters) : NaN;
      pending = isFinite(pending) && pending > 0 ? pending : 0;
      var effMeters = pending > 0 ? pending : qty * pieceMpu;

      box.querySelectorAll('.lp2__row').forEach(function (r) {
        var rq = parseInt(r.dataset.lpQty, 10);
        var active =
          (rq === 1 && effMeters >= 1 && effMeters < 2) ||
          (rq === 2 && effMeters >= 2 && effMeters < min3) ||
          (rq >= min3 && effMeters >= min3);
        r.classList.toggle('is-active', active);
      });

      // 2026-08-26: whichever tier is currently active (same effMeters/min3
      // selection the row highlighting above and the sign-in prompt below
      // both use), reused to keep the main product price display in sync
      // with the ladder.
      var tierQty = effMeters >= min3 ? min3 : (effMeters >= 2 ? 2 : 1);
      var activeRate = rateFor(tierQty, base);
      var topPriceEl = document.querySelector('#product-price .product-info__price-sale, #product-price .product-info__price-current');
      if (topPriceEl) topPriceEl.textContent = money(activeRate);

      // 2026-08-26: strike through the base price alongside the discounted
      // rate once a tier discount is actually active — mirrors the cart
      // line item's own discounted-price + strikethrough-original pattern.
      // Only touches #product-price-compare, the hidden span rendered for
      // products with NO real Shopify sale — a product that DOES have a
      // real compare_at_price sale already shows its own compare span
      // (untouched here), left as a real sale reference regardless of the
      // ladder tier, same as before.
      var topComparePriceEl = document.getElementById('product-price-compare');
      if (topComparePriceEl) {
        if (activeRate < base) {
          topComparePriceEl.textContent = money(base);
          topComparePriceEl.hidden = false;
        } else {
          topComparePriceEl.hidden = true;
        }
      }

      // 2026-08-15: "Sign in for a better price" — originally recomputed for
      // whichever tier was CURRENTLY active, which meant it disappeared at
      // 1 meter (no discount applies there regardless of signed-in status,
      // since tier2/tier3 percentages only kick in at qty>=2/min3).
      // 2026-08-26: now shows for a guest regardless of which row is
      // currently selected — checks across ALL tiers (2 and 3, both the
      // logged-in and recent-buyer configs) rather than just the active
      // one, so it only stays hidden if signing in genuinely wouldn't help
      // at ANY quantity, not just the one currently picked.
      if (signinEl) {
        var maxDelta = Math.max(liT2 - t2, liT3 - t3, rbT2 - t2, rbT3 - t3);
        if (maxDelta > 0) {
          if (signinTitleEl) {
            signinTitleEl.textContent = 'Sign in — you may unlock more savings';
          }
          if (signinSubEl) {
            signinSubEl.hidden = true;
          }
          signinEl.hidden = false;
        } else {
          signinEl.hidden = true;
        }
      }

      box.hidden = false;
    }

    box.addEventListener('click', function (e) {
      if (box.classList.contains('lp2--readonly')) return;
      var row = e.target.closest('.lp2__row');
      if (!row) return;
      var mi = document.getElementById('meter-input');
      if (!mi) return;
      mi.value = row.dataset.lpQty;
      mi.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    });

    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'meter-input' || e.target.name === 'id')) render();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('#qty-minus, #qty-plus')) setTimeout(render, 0);
      if (e.target.closest('[data-quantity-presets-block]')) {
        setTimeout(render, 0);
        setTimeout(render, 700);
      }
    });

    render();

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // merchant control: "always" or "peak_only" (only when quantity_ladder_config.isPeak is true)
    (function () {
      var cdEl = document.getElementById('lp2-countdown');
      var raw = box.getAttribute('data-valid-until');
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = 'Offer ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ladder-pricing"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('ladder-pricing');
    if (!box) return;

    var t2 = parseFloat(box.dataset.t2) || 0;
    var t3 = parseFloat(box.dataset.t3) || 0;
    var min3 = parseInt(box.dataset.min3, 10) || 3;

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // merchant control: "always" or "peak_only" (only when quantity_ladder_config.isPeak is true)
    (function () {
      var cdEl = document.getElementById('ladder-pricing-countdown');
      var raw = box.getAttribute('data-valid-until');
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = 'Offer ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();

    function variantData() {
      var el = document.getElementById('ladder-pricing-variants');
      if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
      return [];
    }

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      var vs = variantData();
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(inp.value)) return vs[i];
      }
      return null;
    }

    function money(sub) {
      // whole-rupee display per the discount-tier instruction
      return '₹' + Math.round(sub / 100).toLocaleString('en-IN');
    }

    function rateFor(qty, base) {
      if (qty >= min3) return Math.round(base * (100 - t3) / 100);
      if (qty === 2) return Math.round(base * (100 - t2) / 100);
      return base;
    }

    function pageQty() {
      var mi = document.getElementById('meter-input');
      var q = mi ? parseInt(mi.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function pendingMeters() {
      // calculator presets that don't switch variants store the true length here
      var form = document.getElementById('product-form');
      if (!form) return 0;
      var m = parseFloat(form.dataset.qtyPresetPendingMeters);
      return isFinite(m) && m > 0 ? m : 0;
    }

    function groupKey(v) {
      return (v.option1 || '') + '|||' + (v.option2 || '');
    }

    // "price for 1 meter" reference: the CURRENT variant if already whole-meter, else
    // the first whole-meter sibling in its own fabric group — not just the first
    // whole-meter variant anywhere on the product (broke rates across fabric groups
    // at different price points).
    function baseVariant(v) {
      if (v && v.price && mpu(v.sku) === 1) return v;
      var vs = variantData();
      if (v) {
        var key = groupKey(v);
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].price && mpu(vs[i].sku) === 1 && groupKey(vs[i]) === key) return vs[i];
        }
      }
      for (var j = 0; j < vs.length; j++) {
        if (vs[j].price && mpu(vs[j].sku) === 1) return vs[j];
      }
      return null;
    }

    function render() {
      var v = currentVariant();
      var bv = baseVariant(v);
      if (!v || !bv) { box.hidden = true; return; }

      // fractional cut piece selected (e.g. via the calculator presets): keep the
      // cards visible as reference, highlight by EFFECTIVE meters, but make them
      // display-only and drop the total line (piece pricing is its own number)
      var pieceMpu = mpu(v.sku);
      var fractional = pieceMpu !== 1;
      box.classList.toggle('ladder-pricing--readonly', fractional);

      var base = bv.price;
      var p1 = box.querySelector('[data-lp-price="1"]');
      var p2 = box.querySelector('[data-lp-price="2"]');
      var p3 = box.querySelector('[data-lp-price="3"]');
      if (p1) p1.innerHTML = money(base) + '<small>/m</small>';
      if (p2) p2.innerHTML = money(rateFor(2, base)) + '<small>/m</small>';
      if (p3) p3.innerHTML = money(rateFor(min3, base)) + '<small>/m</small>';

      // absolute savings alongside the percent (per meter)
      var s2 = box.querySelector('[data-lp-save="2"]');
      var s3 = box.querySelector('[data-lp-save="3"]');
      if (s2) s2.textContent = 'Save ' + t2 + '% · ' + money(base - rateFor(2, base)) + '/m';
      if (s3) s3.textContent = 'Save ' + t3 + '% · ' + money(base - rateFor(min3, base)) + '/m';

      var qty = pageQty();
      var pending = pendingMeters();
      var effMeters = pending > 0 ? pending : qty * pieceMpu;
      // range-based highlight: 1 ≤ eff < 2 → card 1; 2 ≤ eff < min3 → card 2; eff ≥ min3 → card 3
      box.querySelectorAll('.ladder-pricing__card').forEach(function (c) {
        var cq = parseInt(c.dataset.lpQty, 10);
        var active =
          (cq === 1 && effMeters >= 1 && effMeters < 2) ||
          (cq === 2 && effMeters >= 2 && effMeters < min3) ||
          (cq >= min3 && effMeters >= min3);
        c.classList.toggle('is-active', active);
      });

      function effFmt(n) {
        n = Math.round(n * 10) / 10;
        return n % 1 === 0 ? String(Math.round(n)) : String(n);
      }

      var totalEl = document.getElementById('ladder-pricing-total');
      if (totalEl) {
        if (!v.price || v.price <= 0) { totalEl.hidden = true; totalEl.innerHTML = ''; }
        else {
        totalEl.hidden = false;
        // percent off the ACTUAL selected variant's line total (mirrors the Function),
        // labeled in effective meters so fractional pieces read correctly
        var pct = effMeters >= min3 ? t3 : (effMeters >= 2 ? t2 : 0);
        var orig = pending > 0 ? Math.round(base * pending) : v.price * qty;
        var total = Math.round(orig * (100 - pct) / 100);
        var label = 'Selected: ' + effFmt(effMeters) + ' meter' + (effMeters === 1 ? '' : 's');
        if (total < orig) {
          totalEl.innerHTML = label + ' = <s>' + money(orig) + '</s> <strong>' + money(total) +
            '</strong> · you save ' + money(orig - total);
        } else {
          totalEl.innerHTML = label + ' = <strong>' + money(total) + '</strong>';
        }
        }
      }
      box.hidden = false;
    }

    // card click → set the quantity stepper (everything else syncs via its listeners)
    box.addEventListener('click', function (e) {
      // display-only while a fractional piece variant is selected (calculator owns qty)
      if (box.classList.contains('ladder-pricing--readonly')) return;
      var card = e.target.closest('.ladder-pricing__card');
      if (!card) return;
      var mi = document.getElementById('meter-input');
      if (!mi) return;
      mi.value = card.dataset.lpQty;
      mi.dispatchEvent(new Event('change', { bubbles: true }));
      render();
      // 3+ card: pulse the stepper so it's obvious quantity can go higher
      if (parseInt(card.dataset.lpQty, 10) >= min3) {
        var stepper = mi.closest('.product-quantity__stepper') || mi.parentElement;
        if (stepper) {
          stepper.classList.remove('ladder-pricing-pulse');
          void stepper.offsetWidth;
          stepper.classList.add('ladder-pricing-pulse');
          setTimeout(function () { stepper.classList.remove('ladder-pricing-pulse'); }, 1300);
        }
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'meter-input' || e.target.name === 'id')) render();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('#qty-minus, #qty-plus')) setTimeout(render, 0);
      // calculator writes its pending length AFTER dispatching change events —
      // re-read on the next tick for any interaction inside the presets block
      if (e.target.closest('[data-quantity-presets-block]')) {
        setTimeout(render, 0);
        setTimeout(render, 700);
      }
    });

    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prepaid-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    // Delegated on document, not bound directly — #ppb-apply gets replaced
    // whenever assets/cart.js's refreshSection() rewrites #cart-summary's
    // innerHTML on every cart:updated event, which would kill a direct
    // listener after the first cart change (same reasoning as the
    // repeat-customer banner's own delegated listener).
    //
    // 2026-08-12: switched from a full-page /discount/CODE redirect to the
    // Ajax Cart API's discount param (POST /cart/update.js, {discount: code})
    // — same mechanism already used by the "×" remove button in
    // assets/cart.js. No reload: dispatching cart:updated triggers that
    // file's existing refreshSection(), which does a real ?sections=main-cart
    // fetch (fresh server-rendered Liquid, not a client patch of the AJAX
    // response) — so the row correctly flips to "Applied" once refreshed.
    // Confirmed live via a direct curl test: the response's
    // discount_codes[].applicable field reliably reports whether the code
    // was accepted, unlike cart.discount_applications[].title (unreliable —
    // see the Liquid comment above this file's applied-detection logic).
    // 2026-08-15: the discount param on /cart/update.js REPLACES the whole
    // applied-code list, it doesn't merge — sending just this code alone
    // was silently dropping whatever was already applied (e.g. LOYALTY),
    // which is exactly why two codes couldn't stay combined. Fetch the
    // cart's current discount_codes first and send the union (existing +
    // this one, comma-separated — Shopify's own supported multi-code
    // format) instead of overwriting.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#ppb-apply');
      if (!btn) return;
      var code = btn.getAttribute('data-code');
      if (!code || btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Applying…';
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (currentCart) {
          var existing = (currentCart.discount_codes || [])
            .map(function (dc) { return dc.code; })
            .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
          var combined = existing.concat([code]).join(',');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: combined })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var applied = (cart.discount_codes || []).some(function (dc) {
            return dc.code === code && dc.applicable;
          });
          if (!applied) {
            btn.disabled = false;
            btn.textContent = 'Not eligible';
            setTimeout(function () { btn.textContent = originalText; }, 2000);
            return;
          }
          // Dispatching (not calling refreshSection() directly) matches the
          // "×" remove handler's own reasoning — lets the global
          // prepaid_discount_applied reconciliation in layout/theme.liquid
          // also pick this up, not just this file's own re-render.
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["print-fabric-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('pfp');
    if (!box) return;

    function parseJSON(id, fb) {
      var el = document.getElementById(id);
      if (!el) return fb;
      try { return JSON.parse(el.textContent) || fb; } catch (e) { return fb; }
    }

    var qualities = parseJSON('pfp-qualities', []) || [];
    qualities.sort(function (a, b) { return String(a.name || '').localeCompare(String(b.name || '')); });
    var variants = parseJSON('pfp-variants', []) || [];
    var pageProduct = parseJSON('pfp-product', {}) || {};
    if (!qualities.length) return; // extra safety even though Liquid already gated this

    // Find a variant whose SKU cleanly splits into the expected 4 segments
    // (PREFIX-SUB-DESIGNCODE-SUFFIX) — search ALL of this product's variants,
    // not just whichever is currently selected, since the selected one may be
    // a fractional cut-piece variant with an extra SKU segment.
    var designNumber = null;
    for (var i = 0; i < variants.length; i++) {
      var parts = String(variants[i].sku || '').split('-');
      if (parts.length === 4) { designNumber = parts[2]; break; }
    }
    if (!designNumber) return; // no variant has a usable SKU — feature unavailable on this product

    var fieldEl = document.getElementById('pfp-field');
    var fieldNameEl = document.getElementById('pfp-field-name');
    var fieldWidthEl = document.getElementById('pfp-field-width');
    var fieldPriceEl = document.getElementById('pfp-field-price');
    var overlay = document.getElementById('pfp-overlay');
    var overlayBackdrop = document.getElementById('pfp-overlay-backdrop');
    var overlayClose = document.getElementById('pfp-overlay-close');
    var overlayList = document.getElementById('pfp-overlay-list');
    var qtyEl = document.getElementById('pfp-qty');
    var minusBtn = document.getElementById('pfp-minus');
    var plusBtn = document.getElementById('pfp-plus');
    var totalEl = document.getElementById('pfp-total');
    var addBtn = document.getElementById('pfp-add');
    var addBtnDefaultText = addBtn.textContent;

    var selectedIndex = 0;

    function fmtMoney(n) {
      return '₹' + (Math.round((n || 0) * 100) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    qualities.forEach(function (q, i) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'pfp__overlay-row';
      row.setAttribute('data-index', String(i));
      row.innerHTML =
        '<span class="pfp__overlay-row-main">' +
          '<span class="pfp__overlay-row-name">' + (q.name || '') + '</span>' +
          (q.width ? '<span class="pfp__overlay-row-width">' + q.width + '</span>' : '') +
        '</span>' +
        '<span class="pfp__overlay-row-price">' + fmtMoney(q.price_per_meter) + '/meter</span>';
      overlayList.appendChild(row);
    });

    function selectedQuality() {
      return qualities[selectedIndex] || null;
    }
    function qty() {
      var q = parseInt(qtyEl.value, 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function renderField() {
      var q = selectedQuality();
      if (!q) return;
      fieldNameEl.textContent = q.name || '';
      fieldWidthEl.textContent = q.width || '';
      fieldPriceEl.textContent = fmtMoney(q.price_per_meter) + '/meter';
      overlayList.querySelectorAll('.pfp__overlay-row').forEach(function (row) {
        row.classList.toggle('is-selected', Number(row.getAttribute('data-index')) === selectedIndex);
      });
    }

    function render() {
      var q = selectedQuality();
      if (!q) { totalEl.textContent = ''; addBtn.disabled = true; return; }
      totalEl.textContent = fmtMoney((q.price_per_meter || 0) * qty());
      // variant_id is guaranteed present per the sync job's own contract, but
      // this is defensive insurance, not the primary safety net — "shouldn't
      // happen" isn't "can't happen".
      addBtn.disabled = !q.variant_id;
    }

    function openOverlay() {
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeOverlay() {
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    fieldEl.addEventListener('click', openOverlay);
    overlayClose.addEventListener('click', closeOverlay);
    overlayBackdrop.addEventListener('click', closeOverlay);

    overlayList.addEventListener('click', function (e) {
      var row = e.target.closest('.pfp__overlay-row');
      if (!row) return;
      selectedIndex = Number(row.getAttribute('data-index'));
      renderField();
      render();
      closeOverlay();
    });

    qtyEl.addEventListener('input', render);
    minusBtn.addEventListener('click', function () {
      qtyEl.value = Math.max(1, qty() - 1);
      render();
    });
    plusBtn.addEventListener('click', function () {
      qtyEl.value = qty() + 1;
      render();
    });

    addBtn.addEventListener('click', function () {
      var q = selectedQuality();
      if (!q || !q.variant_id) return;
      var constructedSku = (q.sku_prefix || '') + '-' + (q.sku_sub_prefix || '') + '-' + designNumber + '-' + (q.sku_suffix || '');

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      // Same /cart/add.js + cart:added + window.__cartAdded fallback contract
      // as the page's own native Add to Cart button (assets/product.js) —
      // keeps the cart drawer/badge behavior identical for this button too.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: q.variant_id,
          quantity: qty(),
          properties: {
            'SKU': constructedSku,
            // "_"-prefixed = Shopify's own convention for internal-only
            // properties — hidden from the customer-visible properties list,
            // used only as a cart-line image fallback (see cart-line-item.liquid)
            // since the shared proxy product itself has no image of its own.
            '_design_image': pageProduct.image || ''
          }
        })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) {
              var err = new Error((data && (data.description || data.message)) || 'Could not add to cart. Please try again.');
              err.cartError = true;
              throw err;
            }
            return data;
          });
        })
        .then(function (item) {
          showPickerError('');
          addBtn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:added', { detail: item }));
          if (window.__cartAdded) {
            window.__cartAdded(item);
          } else {
            var countEl = document.querySelector('.header__cart-count');
            if (countEl) {
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? '' : 'none';
              });
            }
          }
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = addBtnDefaultText;
          }, 1500);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.textContent = addBtnDefaultText;
          showPickerError(err && err.cartError ? err.message : 'Could not add to cart. Please try again.');
        });
    });

    function showPickerError(msg) {
      var errEl = document.getElementById('pfp-atc-error');
      if (!msg) { if (errEl) errEl.textContent = ''; return; }
      if (!errEl) {
        errEl = document.createElement('p');
        errEl.id = 'pfp-atc-error';
        errEl.setAttribute('role', 'alert');
        errEl.style.cssText = 'font-size:0.8125rem;color:#b23b3b;margin-top:0.5rem;';
        addBtn.parentNode.appendChild(errEl);
      }
      errEl.textContent = msg;
    }

    renderField();
    render();
    box.hidden = false;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__quick-view');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-url').split('/products/')[1].split('?')[0];
      var cardImg = btn.closest('.product-card__media').querySelector('.product-card__img--primary');
      var imgSrc = cardImg ? cardImg.src : '';
      var extraData = {
        meta: btn.getAttribute('data-card-meta') || '',
        reviewAvg: parseInt(btn.getAttribute('data-review-avg')) || 0,
        reviewCount: parseInt(btn.getAttribute('data-review-count')) || 0,
        rateUnit: btn.getAttribute('data-rate-unit') || ''
      };
      if (window.__qvOpen) {
        window.__qvOpen(handle, imgSrc, extraData);
      } else {
        window.location.href = btn.getAttribute('data-product-url');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-video-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var popup = document.getElementById('video-popup');
    if (!popup) return;

    var pid = popup.getAttribute('data-product-id');
    var storageKey = 'vp_dismissed_' + pid;
    try {
      if (pid && sessionStorage.getItem(storageKey)) return;
    } catch (e) {}

    var video = document.getElementById('video-popup-video');
    var closeBtn = document.getElementById('video-popup-close');
    if (!video) return;

    function dismiss() {
      popup.hidden = true;
      try { if (pid) sessionStorage.setItem(storageKey, '1'); } catch (e) {}
      video.pause();
    }

    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    // 2026-08-15: tapping the widget (anywhere except the close button)
    // jumps to the SAME video already playable at full resolution in the
    // main gallery, instead of enlarging this widget's own deliberately
    // low-res source in place — avoids ever showing a stretched/pixelated
    // version. Delegates to the gallery's own thumb-click handler (in
    // assets/product.js, not exposed globally) rather than reimplementing
    // slide-switching here — same delegation pattern already used by
    // ladder-pricing-v2.liquid's switchToVariant().
    popup.addEventListener('click', function (e) {
      if (e.target.closest('.video-popup__close')) return;
      var galleryEl = document.getElementById('gallery-slider');
      var videoThumb = document.querySelector('.product-gallery__thumb--video');
      if (videoThumb) videoThumb.click();
      if (galleryEl) galleryEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      dismiss();
    });

    function reveal() {
      if (popup.hidden === false) return;
      popup.hidden = false;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function startLoadingAndReveal() {
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.preload = 'auto';
      video.src = src;
      video.addEventListener('canplaythrough', reveal, { once: true });
      video.load();
      // Safety net — some browsers don't reliably fire canplaythrough for a
      // muted looping video, or a slow connection just takes a while; don't
      // leave the widget silently never appearing.
      setTimeout(reveal, 4000);
    }

    // 2026-08-26: was window.load alone — now also waits for every product
    // gallery image to finish loading first, so this widget's own 7-18MB
    // download never competes with (or even lands before) the actual
    // product photos the customer is here to see. Duplicated in
    // assets/product.js's own gallery-video loader rather than shared —
    // this is a separate compiled script, no reliable way to guarantee load
    // order between the two files.
    function waitForGalleryImages(callback) {
      var gallery = document.getElementById('product-gallery');
      if (!gallery) { callback(); return; }
      var imgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
      if (!imgs.length) { callback(); return; }
      var remaining = imgs.length;
      var done = false;
      function checkDone() {
        remaining -= 1;
        if (remaining <= 0 && !done) { done = true; callback(); }
      }
      imgs.forEach(function (img) {
        if (img.complete) { checkDone(); return; }
        img.addEventListener('load', checkDone, { once: true });
        img.addEventListener('error', checkDone, { once: true });
      });
    }

    if (document.readyState === 'complete') {
      waitForGalleryImages(startLoadingAndReveal);
    } else {
      window.addEventListener('load', function () {
        waitForGalleryImages(startLoadingAndReveal);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    function __initQuickView() {
    if (window.__qvOpen) return;

    var qvModal = document.getElementById('qv-modal');
    var qvOverlay = document.getElementById('qv-overlay');
    var qvClose = document.getElementById('qv-close');
    var qvImg = document.getElementById('qv-img');
    var qvTitle = document.getElementById('qv-title');
    var qvPrice = document.getElementById('qv-price');
    var qvQtyInput = document.getElementById('qv-qty-input');
    var qvAtc = document.getElementById('qv-atc');
    var qvMeta = document.getElementById('qv-meta');
    var qvStars = document.getElementById('qv-stars');
    var qvViewLink = document.getElementById('qv-view-link');
    var qvSelectedVariant = null;
    var qvRateUnit = '';

    if (!qvModal) return;

    function qvOpenModal() {
      qvModal.classList.add('is-open');
      qvOverlay.classList.add('is-open');
      qvModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function qvCloseModal() {
      qvModal.classList.remove('is-open');
      qvOverlay.classList.remove('is-open');
      qvModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      qvSelectedVariant = null;
    }

    if (qvClose) qvClose.addEventListener('click', qvCloseModal);
    if (qvOverlay) qvOverlay.addEventListener('click', qvCloseModal);

    function qvFormatMoney(cents) {
      return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function qvUpdatePrice() {
      if (!qvSelectedVariant) return;
      var html = '';
      if (qvSelectedVariant.compare_at_price && qvSelectedVariant.compare_at_price > qvSelectedVariant.price) {
        html += '<span class="qv-modal__price-compare">' + qvFormatMoney(qvSelectedVariant.compare_at_price) + '</span>';
      }
      html += '<span>' + qvFormatMoney(qvSelectedVariant.price) + '</span>';
      if (qvRateUnit) {
        html += ' <span class="qv-modal__price-unit">/ ' + qvRateUnit + '</span>';
      }
      qvPrice.innerHTML = html;
      qvAtc.disabled = !qvSelectedVariant.available;
      qvAtc.textContent = qvSelectedVariant.available ? 'Add to Cart' : 'Sold Out';
    }

    function qvRenderStars(avg, count) {
      if (!count) { qvStars.innerHTML = ''; return; }
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var full = i * 10;
        var half = full - 5;
        if (avg >= full) {
          html += '<svg width="13" height="13" viewBox="0 0 24 24" fill="var(--color-gold)" stroke="var(--color-gold)" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
        } else if (avg >= half) {
          html += '<svg width="13" height="13" viewBox="0 0 24 24" stroke="var(--color-gold)" stroke-width="1.5" fill="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z" fill="url(#qv-half)"/><defs><linearGradient id="qv-half"><stop offset="50%" stop-color="var(--color-gold)"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs></svg>';
        } else {
          html += '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--color-gold)" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
        }
      }
      html += '<span class="qv-modal__stars-count">(' + count + ')</span>';
      qvStars.innerHTML = html;
    }

    document.getElementById('qv-qty-minus').addEventListener('click', function() {
      var v = parseInt(qvQtyInput.value) || 1;
      if (v > 1) qvQtyInput.value = v - 1;
    });
    document.getElementById('qv-qty-plus').addEventListener('click', function() {
      var v = parseInt(qvQtyInput.value) || 1;
      qvQtyInput.value = v + 1;
    });

    qvAtc.addEventListener('click', function() {
      if (!qvSelectedVariant || !qvSelectedVariant.available) return;
      qvAtc.classList.add('is-adding');
      qvAtc.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qvSelectedVariant.id, quantity: parseInt(qvQtyInput.value) || 1 })
      })
      .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
      .then(function(res) {
        if (!res.ok) {
          // Shopify blocked it (usually not enough stock) — surface its message.
          qvAtc.classList.remove('is-adding');
          qvAtc.textContent = 'Add to Cart';
          var desc = (res.data && (res.data.description || res.data.message)) || 'Not enough stock available';
          var errEl = document.getElementById('qv-add-error');
          if (!errEl) {
            errEl = document.createElement('div');
            errEl.id = 'qv-add-error';
            errEl.style.cssText = 'font-size:0.8125rem;color:#b23b3b;margin-top:0.5rem;text-align:center;';
            qvAtc.parentNode.appendChild(errEl);
          }
          errEl.textContent = desc;
          return;
        }
        var errClear = document.getElementById('qv-add-error');
        if (errClear) errClear.textContent = '';
        qvAtc.textContent = 'Added!';
        setTimeout(function() {
          qvAtc.classList.remove('is-adding');
          qvCloseModal();
          var drawerEl = document.getElementById('cart-drawer');
          if (drawerEl && drawerEl.classList.contains('is-open') && window.__cartDrawerRefresh) {
            window.__cartDrawerRefresh();
          } else if (window.__cartAdded) {
            window.__cartAdded(res.data);
          } else {
            var countEl = document.querySelector('.header__cart-count');
            if (countEl) {
              fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? '' : 'none';
              });
            }
          }
        }, 600);
      })
      .catch(function() {
        qvAtc.classList.remove('is-adding');
        qvAtc.textContent = 'Add to Cart';
      });
    });

    window.__qvOpen = function(handle, imgSrc, extra) {
      extra = extra || {};
      qvImg.src = imgSrc || '';
      qvTitle.textContent = '';
      qvViewLink.href = '/products/' + handle;
      qvMeta.textContent = extra.meta || '';
      qvRenderStars(extra.reviewAvg, extra.reviewCount);
      qvRateUnit = extra.rateUnit || '';
      document.getElementById('qv-qty-unit').textContent = qvRateUnit ? qvRateUnit : '';
      qvPrice.innerHTML = '';
      qvQtyInput.value = 1;
      qvAtc.textContent = 'Add to Cart';
      qvAtc.classList.remove('is-adding');
      qvAtc.disabled = false;
      qvOpenModal();

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          qvTitle.textContent = product.title;
          qvImg.alt = product.title;
          if (product.featured_image) {
            qvImg.src = product.featured_image.replace(/(\.[^.]+)$/, '_400x$1');
          }
          var firstAvailable = product.variants.find(function(v) { return v.available; }) || product.variants[0];
          qvSelectedVariant = firstAvailable;
          qvUpdatePrice();
        });
    };
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__initQuickView);
  } else {
    document.addEventListener('DOMContentLoaded', __initQuickView);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["repeat-customer-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    // Delegated on document, not bound directly — #rcb-apply gets replaced
    // whenever assets/cart.js's refreshSection() rewrites #cart-summary's
    // innerHTML on every cart:updated event, which would kill a direct
    // listener after the first cart change (same reasoning as the BXGY
    // claim pill's own delegated listener elsewhere in this cart page).
    //
    // 2026-08-12: switched from a full-page /discount/CODE redirect to the
    // Ajax Cart API's discount param (POST /cart/update.js, {discount: code})
    // — same mechanism already used by the "×" remove button in
    // assets/cart.js, and mirrored in prepaid-banner.liquid's identical
    // Apply handler (see that file's comment for the full reasoning/live-test
    // details). No reload: dispatching cart:updated triggers
    // assets/cart.js's existing refreshSection(), a real ?sections=main-cart
    // fetch that re-renders fresh server-side Liquid, so the row correctly
    // flips to "Applied" using the corrected OR-match logic above.
    // 2026-08-15: the discount param on /cart/update.js REPLACES the whole
    // applied-code list, it doesn't merge — sending just this code alone
    // was silently dropping whatever was already applied (e.g. PREPAY),
    // which is exactly why two codes couldn't stay combined. Fetch the
    // cart's current discount_codes first and send the union (existing +
    // this one, comma-separated — Shopify's own supported multi-code
    // format) instead of overwriting. Same fix as prepaid-banner.liquid.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#rcb-apply');
      if (!btn) return;
      var code = btn.getAttribute('data-code');
      if (!code || btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Applying…';
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (currentCart) {
          var existing = (currentCart.discount_codes || [])
            .map(function (dc) { return dc.code; })
            .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
          var combined = existing.concat([code]).join(',');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: combined })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var applied = (cart.discount_codes || []).some(function (dc) {
            return dc.code === code && dc.applicable;
          });
          if (!applied) {
            btn.disabled = false;
            btn.textContent = 'Not eligible';
            setTimeout(function () { btn.textContent = originalText; }, 2000);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fvsShipNotice) return;
    window.__fvsShipNotice = true;

    var DAY = 86400000;
    var IST_OFFSET = 19800000;
    var FORMATS = {
      short: { weekday: 'short', day: 'numeric', month: 'short' },
      day_month: { day: 'numeric', month: 'short' },
      long: { weekday: 'long', day: 'numeric', month: 'long' }
    };
    var timer = null;
    var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var barWidths = typeof WeakMap === 'function' ? new WeakMap() : null;

    function fits(viewport, item) {
      return item.scrollWidth <= viewport.clientWidth + 1;
    }

    function fitBar(bar) {
      var viewport = bar.querySelector('.ship-notice__viewport');
      var track = bar.querySelector('.ship-notice__track');
      var full = track && track.querySelector('[data-sn-full]');
      if (!viewport || !full) return;
      var short = track.querySelector('[data-sn-short]');

      track.querySelectorAll('[data-sn-clone]').forEach(function (n) { n.remove(); });
      bar.classList.remove('is-scrolling', 'is-paused');
      track.style.removeProperty('--sn-dur');
      bar.classList.add('sn-nowrap');
      full.hidden = false;
      if (short) short.hidden = true;
      if (!viewport.clientWidth) { bar.classList.remove('sn-nowrap'); return; }

      var item = full;
      if (!fits(viewport, full) && short) {
        full.hidden = true;
        short.hidden = false;
        item = short;
      }
      if (fits(viewport, item)) return;

      if (bar.hasAttribute('data-sn-scroll') && !reducedMotion.matches) {
        bar.classList.add('is-scrolling');
        var clone = item.cloneNode(true);
        clone.removeAttribute('data-sn-full');
        clone.removeAttribute('data-sn-short');
        clone.setAttribute('data-sn-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        var speed = parseFloat(bar.getAttribute('data-sn-speed')) || 40;
        track.style.setProperty('--sn-dur', (item.getBoundingClientRect().width / speed) + 's');
        return;
      }
      bar.classList.remove('sn-nowrap');
    }

    var barObserver = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var w = Math.round(entry.contentRect.width);
        if (barWidths && barWidths.get(entry.target) === w) return;
        if (barWidths) barWidths.set(entry.target, w);
        fitBar(entry.target);
      });
    }) : null;

    function setupBar(bar) {
      if (!bar.hasAttribute('data-sn-ready')) {
        bar.setAttribute('data-sn-ready', '');
        bar.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' || !bar.classList.contains('is-scrolling')) return;
          bar.classList.toggle('is-paused');
        });
        if (barObserver) barObserver.observe(bar);
      }
      fitBar(bar);
    }

    function formatDate(ms, fmt) {
      var opts = Object.assign({ timeZone: 'Asia/Kolkata' }, FORMATS[fmt] || FORMATS.short);
      var parts = {};
      new Intl.DateTimeFormat('en-US', opts).formatToParts(new Date(ms)).forEach(function (p) { parts[p.type] = p.value; });
      var dayMonth = parts.day + ' ' + parts.month;
      return parts.weekday ? parts.weekday + ', ' + dayMonth : dayMonth;
    }

    function nextIstMidnight(now) {
      return (Math.floor((now + IST_OFFSET) / DAY) + 1) * DAY - IST_OFFSET;
    }

    function evaluate(el, now) {
      var phases = [];
      try { phases = JSON.parse(el.getAttribute('data-sn-phases') || '[]'); } catch (e) {}
      var roll = parseInt(el.getAttribute('data-sn-roll'), 10);
      var end = parseInt(el.getAttribute('data-sn-end'), 10) || 0;
      var label = null;
      var next = Infinity;

      for (var i = 0; i < phases.length; i++) {
        if (now < phases[i].u) { label = phases[i].l; next = phases[i].u; break; }
      }
      if (label === null && roll >= 0) {
        label = formatDate(now + roll * DAY, el.getAttribute('data-sn-fmt'));
        next = nextIstMidnight(now);
      }
      if (end) {
        if (now >= end) label = null;
        else if (end < next) next = end;
      }

      if (label === null) { el.hidden = true; return Infinity; }
      el.hidden = false;
      el.querySelectorAll('[data-sn-date]').forEach(function (n) {
        if (n.textContent !== label) n.textContent = label;
      });
      return next;
    }

    var glowObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-glowing');
        glowObserver.unobserve(entry.target);
      });
    }, { threshold: 0.6 }) : null;

    function run() {
      clearTimeout(timer);
      var now = Date.now();
      var next = Infinity;
      document.querySelectorAll('[data-ship-notice]').forEach(function (el) {
        next = Math.min(next, evaluate(el, now));
        var bar = el.querySelector('[data-sn-bar]');
        if (bar && !el.hidden) setupBar(bar);
        if (glowObserver && el.classList.contains('ship-notice--glow') && !el.hasAttribute('data-sn-glow')) {
          el.setAttribute('data-sn-glow', '');
          glowObserver.observe(el);
        }
      });
      if (next !== Infinity) {
        timer = setTimeout(run, Math.min(Math.max(next - now + 500, 1000), 2147483000));
      }
    }

    function init() {
      run();
      var summary = document.getElementById('cart-summary');
      if (summary && 'MutationObserver' in window) {
        new MutationObserver(function () { run(); }).observe(summary, { childList: true });
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden) run(); });
      document.addEventListener('shopify:section:load', run);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', run);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welcome-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    // Delegated on document, not bound directly — #wcb-apply gets replaced
    // whenever assets/cart.js's refreshSection() rewrites #cart-summary's
    // innerHTML on every cart:updated event. Same combine-safe apply flow
    // already fixed in repeat-customer-banner.liquid/prepaid-banner.liquid
    // earlier the same day: fetch current discount_codes first and send
    // the union, since the discount param on /cart/update.js REPLACES the
    // whole list rather than merging with it.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#wcb-apply');
      if (!btn) return;
      var code = btn.getAttribute('data-code');
      if (!code || btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Applying…';
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (currentCart) {
          var existing = (currentCart.discount_codes || [])
            .map(function (dc) { return dc.code; })
            .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
          var combined = existing.concat([code]).join(',');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: combined })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var applied = (cart.discount_codes || []).some(function (dc) {
            return dc.code === code && dc.applicable;
          });
          if (!applied) {
            btn.disabled = false;
            btn.textContent = 'Not eligible';
            setTimeout(function () { btn.textContent = originalText; }, 2000);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-engine"] && !Shopify.designMode) return;
  try {
    function __initWishlist() {
    var KEY = 'fvs_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch(e) { return []; }
    }

    function saveWishlist(list) {
      var payload = JSON.stringify(list);
      try {
        localStorage.setItem(KEY, payload);
      } catch (e) {
        // Storage full (third-party trackers can eat the whole quota) —
        // drop known junk keys and retry once so the wishlist keeps working.
        try {
          localStorage.removeItem('stape_events');
          localStorage.removeItem('__uc_site');
          localStorage.setItem(KEY, payload);
        } catch (e2) { /* still full — give up silently */ }
      }
      updateBadges();
    }

    function isInWishlist(handle) {
      return getWishlist().some(function(item) { return item.handle === handle; });
    }

    function addToWishlist(data) {
      var list = getWishlist();
      if (!list.some(function(item) { return item.handle === data.handle; })) {
        list.push(data);
        saveWishlist(list);
      }
    }

    function updateItem(handle, updates) {
      var list = getWishlist();
      var changed = false;
      list.forEach(function(item) {
        if (item.handle === handle) {
          Object.keys(updates).forEach(function(k) {
            if (updates[k] && !item[k]) {
              item[k] = updates[k];
              changed = true;
            }
          });
        }
      });
      if (changed) localStorage.setItem(KEY, JSON.stringify(list));
    }

    function removeFromWishlist(handle) {
      var list = getWishlist().filter(function(item) { return item.handle !== handle; });
      saveWishlist(list);
    }

    function updateBadges() {
      var count = getWishlist().length;
      document.querySelectorAll('.wl-badge').forEach(function(badge) {
        badge.textContent = count;
        badge.classList.toggle('is-visible', count > 0);
      });
    }

    function showToast(msg) {
      var toast = document.getElementById('wl-toast');
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-visible');
      clearTimeout(toast._timer);
      toast._timer = setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 2000);
    }

    function getCardData(card) {
      var link = card.querySelector('.product-card__link');
      var titleEl = card.querySelector('.product-card__title');
      var imgEl = card.querySelector('.product-card__img--primary');
      var priceEl = card.querySelector('.product-card__price--current');
      var compareEl = card.querySelector('.product-card__price--compare');
      var unitEl = card.querySelector('.product-card__price-unit');
      var meta = card.getAttribute('data-wl-meta') || '';
      var rateUnit = card.getAttribute('data-wl-unit') || '';
      var handle = link ? link.getAttribute('href').split('/products/')[1] : '';
      if (handle) handle = handle.split('?')[0].split('#')[0];

      return {
        handle: handle,
        title: titleEl ? titleEl.textContent.trim() : '',
        img: imgEl ? imgEl.src : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        comparePrice: compareEl ? compareEl.textContent.trim() : '',
        url: link ? link.getAttribute('href') : '/products/' + handle,
        meta: meta,
        rateUnit: rateUnit
      };
    }

    function initHearts() {
      document.querySelectorAll('.product-card').forEach(function(card) {
        if (card.querySelector('.wl-heart')) return;
        var link = card.querySelector('.product-card__link');
        if (!link) return;
        var handle = link.getAttribute('href').split('/products/')[1];
        if (!handle) return;
        handle = handle.split('?')[0].split('#')[0];
        var media = card.querySelector('.product-card__media');
        if (!media) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wl-heart';
        btn.setAttribute('aria-label', 'Add to wishlist');
        btn.setAttribute('data-wl-handle', handle);
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>';

        if (isInWishlist(handle)) {
          btn.classList.add('is-active');
          var meta = card.getAttribute('data-wl-meta') || '';
          var rateUnit = card.getAttribute('data-wl-unit') || '';
          if (meta || rateUnit) {
            updateItem(handle, { meta: meta, rateUnit: rateUnit });
          }
        }

        media.appendChild(btn);
      });
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.wl-heart');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-wl-handle');
      var card = btn.closest('.product-card');

      if (isInWishlist(handle)) {
        removeFromWishlist(handle);
        btn.classList.remove('is-active');
        showToast('Removed from wishlist');
      } else {
        var data = getCardData(card);
        addToWishlist(data);
        btn.classList.add('is-active');
        showToast('Added to wishlist');
        var wlIcon = document.querySelector('.header__wl-btn');
        var cardImg = card.querySelector('.product-card__img--primary');
        if (wlIcon && cardImg) flyTo(btn, wlIcon, cardImg.src);
      }
    });

    function flyTo(sourceEl, destEl, imgSrc) {
      if (!sourceEl || !destEl || !imgSrc) return;
      var sR = sourceEl.getBoundingClientRect();
      var dR = destEl.getBoundingClientRect();
      var sx = sR.left + sR.width / 2;
      var sy = sR.top + sR.height / 2;
      var dx = dR.left + dR.width / 2;
      var dy = dR.top + dR.height / 2;

      var el = document.createElement('div');
      el.className = 'fly-item';
      el.style.setProperty('--fly-w', Math.min(sR.width, 80) + 'px');
      el.style.setProperty('--fly-h', Math.min(sR.height, 100) + 'px');
      el.style.setProperty('--fly-sx', sx + 'px');
      el.style.setProperty('--fly-sy', sy + 'px');
      el.style.setProperty('--fly-tx', (dx - sx) + 'px');
      el.style.setProperty('--fly-ty', (dy - sy) + 'px');
      el.style.backgroundImage = 'url(' + imgSrc + ')';
      document.body.appendChild(el);

      el.addEventListener('animationend', function() { el.remove(); });
      setTimeout(function() { el.remove(); }, 800);
    }

    window.__wl = {
      get: getWishlist,
      add: addToWishlist,
      remove: removeFromWishlist,
      isIn: isInWishlist,
      updateBadges: updateBadges,
      initHearts: initHearts,
      updateItem: updateItem
    };

    window.__flyTo = flyTo;

    updateBadges();
    initHearts();
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__initWishlist);
  } else {
    document.addEventListener('DOMContentLoaded', __initWishlist);
  }
  } catch(e) { console.error(e); }
})();

})();
